{
  "schemaVersion": 1,
  "weapons": {
    "bombpack": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/16/frame-01.png",
          "/game/characters/attack-movies/16/frame-02.png",
          "/game/characters/attack-movies/16/frame-03.png",
          "/game/characters/attack-movies/16/frame-04.png",
          "/game/characters/attack-movies/16/frame-05.png",
          "/game/characters/attack-movies/16/frame-06.png",
          "/game/characters/attack-movies/16/frame-07.png",
          "/game/characters/attack-movies/16/frame-08.png",
          "/game/characters/attack-movies/16/frame-02.png",
          "/game/characters/attack-movies/16/frame-01.png",
          "/game/characters/attack-movies/16/frame-08.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/16/frame-01.png",
              "/game/characters/attack-movies/16/frame-02.png",
              "/game/characters/attack-movies/16/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/16/frame-04.png",
              "/game/characters/attack-movies/16/frame-05.png",
              "/game/characters/attack-movies/16/frame-06.png",
              "/game/characters/attack-movies/16/frame-07.png",
              "/game/characters/attack-movies/16/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/16/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie16",
        "sourceCharacterId": 9,
        "sourceChildSymbol": "_16_fla._1_12",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/16.swf",
        "sourceSha256": "533fcad474c71076f1a62a785feca1f687850bca583682c86e427801398b95e1",
        "frameSha256": [
          "03e9ad0d6d21ae37ae811fd9dd950afb9acf50828e5f9f22cf491af42557f225",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "424d2cec9ced1f85cf7b505cae0752462320471634c521a4ede367d83857344d",
          "1cdba3bbf68354313461ebf2b0a55727335c6c4461251c9493fe4d92105dea23",
          "6470533e4315629f69112064a287cf1a2e46d1c6eaa19c036fd7610c5451cbf7",
          "dd8597d8bddaadf78a5a05a367d96c34917fc444ab89a705555f5c4f678ce7ca",
          "91d41e8dae5e546853038df5655a740cd216ac90cc2be56a648a9e51cb187b58",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "03e9ad0d6d21ae37ae811fd9dd950afb9acf50828e5f9f22cf491af42557f225",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "161",
        "vectorFrameSha256": [
          "c46de05e507e7b19e555a451844d957518e2ed1adc00a78c1ce967aa845cf97a",
          "8f91f94a940b2e216d50c820e23f954a3ab5d0e6979435b07f65350272c76bed",
          "ff627d9dc224cea08a21471e478092477b82f938b5d2a5976be3af8aaf224844",
          "e7bf68bb2f87745bb8f4c6a9382bd34ef2e62aa6f0110bbea5d8bb5dec3e0c08",
          "47b2b18ec317af9d4b18ead9a1710eaff4e17387941277b357edc31380b16d0a",
          "a53bd647e41826de77eb036d49a858858fb51ad2dcccca043fdc610acd4bc867",
          "10c4a5a85aa2489cd63fd0a3f349d119e7c121cf18a709c102dd4672f886961b",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4",
          "8f91f94a940b2e216d50c820e23f954a3ab5d0e6979435b07f65350272c76bed",
          "c46de05e507e7b19e555a451844d957518e2ed1adc00a78c1ce967aa845cf97a",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/17/frame-01.png",
          "/game/characters/attack-movies/17/frame-02.png",
          "/game/characters/attack-movies/17/frame-03.png",
          "/game/characters/attack-movies/17/frame-04.png",
          "/game/characters/attack-movies/17/frame-05.png",
          "/game/characters/attack-movies/17/frame-06.png",
          "/game/characters/attack-movies/17/frame-07.png",
          "/game/characters/attack-movies/17/frame-08.png",
          "/game/characters/attack-movies/17/frame-02.png",
          "/game/characters/attack-movies/17/frame-01.png",
          "/game/characters/attack-movies/17/frame-08.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/17/frame-01.png",
              "/game/characters/attack-movies/17/frame-02.png",
              "/game/characters/attack-movies/17/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/17/frame-04.png",
              "/game/characters/attack-movies/17/frame-05.png",
              "/game/characters/attack-movies/17/frame-06.png",
              "/game/characters/attack-movies/17/frame-07.png",
              "/game/characters/attack-movies/17/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/17/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie17",
        "sourceCharacterId": 9,
        "sourceChildSymbol": "_17_fla._1_12",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/17.swf",
        "sourceSha256": "a73dd339a9062b9c046befb8f51e01c1939552921b154a0fdcd2f2f002ae8e18",
        "frameSha256": [
          "72ec3a7250c138750ab5925cc2b06fe7872108267aab8e3ced8e319e41f4c7ac",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "3ec5809723a7fd707994f1ab9b9a970b8deca457288ab85abc0ed597327c55b9",
          "76123f312bb0a006e8d8ce48be25a755eee9bbebb0a1ea832037b23cc3077c7c",
          "ae7947a9a4734974596b9b0d378adb53bf4ec6d642a33f8b637043df9a754554",
          "40ea0f5951cbac50baa804b7f26fcc19eea6e6482b1f54d377b7d9922efc295c",
          "c82048c8d2c6f04e5ac56bc67d43871b597b27d1b66dc8bdfa20328429a89af1",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "72ec3a7250c138750ab5925cc2b06fe7872108267aab8e3ced8e319e41f4c7ac",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "171",
        "vectorFrameSha256": [
          "e1a53647232424e3266aa86fea800a3e007e65fe9dc7433013efb6e8a421305e",
          "ac2f801c5afb17f976e31fbfef22a6c86f12f167e02cbb022a5cb00c54fe3eea",
          "a34acfa6b7091dce04754b93c971c9bc2a08d6791461f17ce8471bbcb76387b7",
          "3902ce216ff06ef650992b3bf01f3def2099af293da3d477ec67066e06795459",
          "ddee4a05315124720b86e54e165677bf187fadf06c81b800553ef7c2e43c2e61",
          "58d1d6780beb30af424ae77f65599b15c64247b7b234a43b6f4ee56e729f3c41",
          "73cea9ee7e0562e9759c6df421f9cebdfa8e29cd95cbb39ab4a083ef7bc82767",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4",
          "ac2f801c5afb17f976e31fbfef22a6c86f12f167e02cbb022a5cb00c54fe3eea",
          "e1a53647232424e3266aa86fea800a3e007e65fe9dc7433013efb6e8a421305e",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      }
    },
    "bomb": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/10/frame-01.png",
          "/game/characters/attack-movies/10/frame-02.png",
          "/game/characters/attack-movies/10/frame-03.png",
          "/game/characters/attack-movies/10/frame-04.png",
          "/game/characters/attack-movies/10/frame-05.png",
          "/game/characters/attack-movies/10/frame-06.png",
          "/game/characters/attack-movies/10/frame-07.png",
          "/game/characters/attack-movies/10/frame-02.png",
          "/game/characters/attack-movies/10/frame-01.png",
          "/game/characters/attack-movies/10/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/10/frame-01.png",
              "/game/characters/attack-movies/10/frame-02.png",
              "/game/characters/attack-movies/10/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/10/frame-04.png",
              "/game/characters/attack-movies/10/frame-05.png",
              "/game/characters/attack-movies/10/frame-06.png",
              "/game/characters/attack-movies/10/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/10/frame-02.png",
              "/game/characters/attack-movies/10/frame-01.png",
              "/game/characters/attack-movies/10/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie10",
        "sourceCharacterId": 9,
        "sourceChildSymbol": "_10_fla._1_12",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/10.swf",
        "sourceSha256": "3d4802bf5515038782e3e38af96d57d8bdda14defba94f0419965d52bcb1eda4",
        "frameSha256": [
          "ff852ac6017dbbba39be0c54a734b922f04c4dfe2dee7bc2e4f74da2fe52e2a9",
          "5596a0d4f88e003dd816dee81e2475eb0e8f2ca2af245cf50b70f52791079bdc",
          "22e86fc00ea234312202adeb3f27be84e3fb1c5838af0931d93e9fed07643332",
          "cd601cdd9511d9bfd0ebf8274f17ae41fcfe6cfde011d0f242e56ffd712c1376",
          "0439ae00cdc4049873e9abe0d07be10e04c2bea6e14500d4c77607208e573b5f",
          "98abd395486ad8c670e582ed791f799d893f92f50c8870846433acadebbdd0f3",
          "b54b63aea3868fd60a36c763b20d3a031775ef6f8797731a78e856e688d16582",
          "5596a0d4f88e003dd816dee81e2475eb0e8f2ca2af245cf50b70f52791079bdc",
          "ff852ac6017dbbba39be0c54a734b922f04c4dfe2dee7bc2e4f74da2fe52e2a9",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "101",
        "vectorFrameSha256": [
          "0623573666864f9d35c12ea5bf12ee5b34ca9a05fc048c5f17ff41043bf1c1d2",
          "973f923b67bf8a967af29624e04df66fd29cecfdefd76a7e86bb7a9d9be4f3ad",
          "35ec276e26461d699302ddbc2ad3e1f64c077c823175bf55b8092fe1594346b7",
          "c70d7c5b3db701ca00d6e64f740710710a5c295a930e7b9217ab22aa41f243c4",
          "0531ceaad6f24dbf8e498e9c4ce6f019febf212dfc2bca37dfe2204e635e7101",
          "b8fbafee152e19251ab6f5685314c71e5e00d931e689d034348afef2fc86e971",
          "951c0d7a66fbfc3cbc09554897130e5a1fe726b7c69c7bdaf511a08e4db9bcfd",
          "973f923b67bf8a967af29624e04df66fd29cecfdefd76a7e86bb7a9d9be4f3ad",
          "0623573666864f9d35c12ea5bf12ee5b34ca9a05fc048c5f17ff41043bf1c1d2",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/11/frame-01.png",
          "/game/characters/attack-movies/11/frame-02.png",
          "/game/characters/attack-movies/11/frame-03.png",
          "/game/characters/attack-movies/11/frame-04.png",
          "/game/characters/attack-movies/11/frame-05.png",
          "/game/characters/attack-movies/11/frame-06.png",
          "/game/characters/attack-movies/11/frame-07.png",
          "/game/characters/attack-movies/11/frame-02.png",
          "/game/characters/attack-movies/11/frame-01.png",
          "/game/characters/attack-movies/11/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/11/frame-01.png",
              "/game/characters/attack-movies/11/frame-02.png",
              "/game/characters/attack-movies/11/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/11/frame-04.png",
              "/game/characters/attack-movies/11/frame-05.png",
              "/game/characters/attack-movies/11/frame-06.png",
              "/game/characters/attack-movies/11/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/11/frame-02.png",
              "/game/characters/attack-movies/11/frame-01.png",
              "/game/characters/attack-movies/11/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie11",
        "sourceCharacterId": 9,
        "sourceChildSymbol": "_11_fla._1_12",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/11.swf",
        "sourceSha256": "6213f8b28fd139264a04f11ecf11a0c3711cb863cd1f297612782526eef3ff82",
        "frameSha256": [
          "aa261bceb736f806da6462ae2c0f7af7264c0ff7b70d67055ce9b866fa976ef5",
          "177d2b64d51922212678a2c4c612181c270c9d855ee0c3cc8fdbb23fbec653e5",
          "6d125f69cfcb6e429be5920ef77e158bbb1f6c8a34878bccaad1df3a8df48159",
          "d9910e7478320ace230904f1a67150ecd8daa8dbdd0b3a4e6360e41da815d500",
          "4e05520d22ff07dd329474f3fbb56d584d3e453204deab55858456dacf1dde40",
          "cae97260cf4c7af8614258fa857eda14f5bb759dcafa786f6d64a7d44271b429",
          "0839c98299ec09ed511918ac641077894c61bdba17518d5ac1a3fa1903fd13f9",
          "177d2b64d51922212678a2c4c612181c270c9d855ee0c3cc8fdbb23fbec653e5",
          "aa261bceb736f806da6462ae2c0f7af7264c0ff7b70d67055ce9b866fa976ef5",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "111",
        "vectorFrameSha256": [
          "f465cdc220d93391b5e425a59f97768eded19365cd6d4e08b118fd175feb13a6",
          "0beaeebfdb0d571271078cfadd00d08d8fafa3f249ce5c1a5eac59aa690cca1d",
          "49a693ab753de4680eb392bf084190db3da226ff6ce95c6d1ac987a681f1e23a",
          "8292719cfe4b0f399a8bda5c5815714a42c7033b564d7065e1a23907fa4d6b48",
          "ec7a9f487530e56830cfcbccecebbcc758d7a0ddac6b231b8782ef60b642cf6a",
          "60a14463a8c94f20252559b371a35915ce195a9ebf8718bcd1e87ed3caff511d",
          "10c8a99ee09da7ac0696ef98efebe6d645fd530a7889fc73769448ed9c3a2a5f",
          "0beaeebfdb0d571271078cfadd00d08d8fafa3f249ce5c1a5eac59aa690cca1d",
          "f465cdc220d93391b5e425a59f97768eded19365cd6d4e08b118fd175feb13a6",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      }
    },
    "dart": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/12/frame-01.png",
          "/game/characters/attack-movies/12/frame-02.png",
          "/game/characters/attack-movies/12/frame-03.png",
          "/game/characters/attack-movies/12/frame-04.png",
          "/game/characters/attack-movies/12/frame-05.png",
          "/game/characters/attack-movies/12/frame-06.png",
          "/game/characters/attack-movies/12/frame-07.png",
          "/game/characters/attack-movies/12/frame-08.png",
          "/game/characters/attack-movies/12/frame-02.png",
          "/game/characters/attack-movies/12/frame-01.png",
          "/game/characters/attack-movies/12/frame-08.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/12/frame-01.png",
              "/game/characters/attack-movies/12/frame-02.png",
              "/game/characters/attack-movies/12/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/12/frame-04.png",
              "/game/characters/attack-movies/12/frame-05.png",
              "/game/characters/attack-movies/12/frame-06.png",
              "/game/characters/attack-movies/12/frame-07.png",
              "/game/characters/attack-movies/12/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/12/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie12",
        "sourceCharacterId": 9,
        "sourceChildSymbol": "_12_fla._1_12",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/12.swf",
        "sourceSha256": "885c9b479427a186ad254240984cc00749cead5797467e1c01cfb71a465a8b8a",
        "frameSha256": [
          "59758358ed441949fcb55dfb3c262faf5cf4e090db251797074a7b43faafc620",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "1addc3fab4926f17c9a699d3e6fdf55d2ffd0557f0eeb6fc379e22fe77c90464",
          "126a52fa7eb5cce7e6c867e1b6f99d2c5da82b4984a45695230c5160d80f9b08",
          "82bcb420f0bcd8e28fbc440c8588eded0b3e8810e1bd399c7462491a4c1f889f",
          "5449d6aa792b05917e81dacff14dbad6220ec29a3d99c1a09b57030b2b9ade79",
          "914d7eadff2b6acd50598c7568d3f48e51ed438597545b81f4c2d17e727872cb",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "59758358ed441949fcb55dfb3c262faf5cf4e090db251797074a7b43faafc620",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "121",
        "vectorFrameSha256": [
          "25a6eecda3ddb12aa403bf6b49e90685b5a0c2d923efa7f5737a89f8f904a20e",
          "a859036f0ff43797e00eb3a55c8fa1deef90d1e98fc274de8f5e6ff98a69d573",
          "01876376ab7986507266297d324e3e3c44e72c548dfe422a73187c64a56afcfc",
          "481610a5c23bda099739ad89d79f8dfe0d5b32153d2dfd5ad4913a6356494a24",
          "19d814c9071afd42e43ce01b8b6d80b01962416643de9378296d36cae129af36",
          "5cf1f7a0e7050942af6405892eef183179a13fa87f666f28f45acdd7f7e4498b",
          "530e27207c121fb56999e663518650b2f1676e5da2c19830275c6369d500f710",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4",
          "a859036f0ff43797e00eb3a55c8fa1deef90d1e98fc274de8f5e6ff98a69d573",
          "25a6eecda3ddb12aa403bf6b49e90685b5a0c2d923efa7f5737a89f8f904a20e",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/13/frame-01.png",
          "/game/characters/attack-movies/13/frame-02.png",
          "/game/characters/attack-movies/13/frame-03.png",
          "/game/characters/attack-movies/13/frame-04.png",
          "/game/characters/attack-movies/13/frame-05.png",
          "/game/characters/attack-movies/13/frame-06.png",
          "/game/characters/attack-movies/13/frame-07.png",
          "/game/characters/attack-movies/13/frame-08.png",
          "/game/characters/attack-movies/13/frame-02.png",
          "/game/characters/attack-movies/13/frame-01.png",
          "/game/characters/attack-movies/13/frame-08.png"
        ],
        "width": 115,
        "height": 96,
        "anchor": {
          "x": 0,
          "y": 1
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/13/frame-01.png",
              "/game/characters/attack-movies/13/frame-02.png",
              "/game/characters/attack-movies/13/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/13/frame-04.png",
              "/game/characters/attack-movies/13/frame-05.png",
              "/game/characters/attack-movies/13/frame-06.png",
              "/game/characters/attack-movies/13/frame-07.png",
              "/game/characters/attack-movies/13/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/13/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie13",
        "sourceCharacterId": 9,
        "sourceChildSymbol": "_13_fla._1_12",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          -1
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/13.swf",
        "sourceSha256": "e6f37ea8ef2bfa62fb2ab1db1848d1ab6d0caab6a4d46b45c044754962d60be6",
        "frameSha256": [
          "b1cdeb100f42b999544839e0560383fb4ad357f1fad140779f7a48b317e5f4d1",
          "3d1d05ef2e1db1ccdf5e6c141361a89ff67dd8ab55b3fb967774d80f3d1517e6",
          "0be130e98cbb841ae96bac3068e7331f5428af15c5f7969bbeaacacda7d083ef",
          "6b8b6238757ab1bc0e80c7de70599a4f11d49cbf1dac248b3a6134a403fd7c3d",
          "c3e5c3881ac0eb96e0d292858b9d21ca572fb26965e1ead0ae2837d2bbade5f2",
          "60b1d7dd6a2a8b90d4daeb4a02ca88920fecaaa9eb4c0c06795bb71fcd9c1c85",
          "1cb6a8310da42e1c711828575034fe32826b38c62a564a52ea001372e9cfc81b",
          "87529f69844aa84f6da55d3bc9b078a79914572b903bc2b1c86c1016180bc356",
          "3d1d05ef2e1db1ccdf5e6c141361a89ff67dd8ab55b3fb967774d80f3d1517e6",
          "b1cdeb100f42b999544839e0560383fb4ad357f1fad140779f7a48b317e5f4d1",
          "87529f69844aa84f6da55d3bc9b078a79914572b903bc2b1c86c1016180bc356"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "131",
        "vectorFrameSha256": [
          "b9eded4efb3bee37d9fd225c3747dcea490d17ef38f4d3ed5c542913a85c7688",
          "0d04bd468868ee0f65361883abf007be2d5de3fcea8bc44b24010d5dde2a7177",
          "6e5fd74253926649e1de96e69c1571c69cacea77f066fcaa960b3f1f15cabb30",
          "f0233a9a441de1605d26e71289f29d67d470f2ae5dfb9d48b3186f092a0c7677",
          "bc388c77b57d64df50efc6cf5b83cfab3901fd2f16c8eec5504ccb2c7da529a1",
          "999d499ba0c2e47e9df388f609887e7148344370edf28e67cd52411519b50713",
          "f2f835f68b514f9fed3a2b854dd568de5a522c98a496f958343183e517222da2",
          "b9186ebd95dca7a8b563b9747fed5f6b2482ed793fc2e46c1e2b6d999523f60a",
          "0d04bd468868ee0f65361883abf007be2d5de3fcea8bc44b24010d5dde2a7177",
          "b9eded4efb3bee37d9fd225c3747dcea490d17ef38f4d3ed5c542913a85c7688",
          "b9186ebd95dca7a8b563b9747fed5f6b2482ed793fc2e46c1e2b6d999523f60a"
        ]
      }
    },
    "electricbar": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/14/frame-01.png",
          "/game/characters/attack-movies/14/frame-02.png",
          "/game/characters/attack-movies/14/frame-03.png",
          "/game/characters/attack-movies/14/frame-04.png",
          "/game/characters/attack-movies/14/frame-05.png",
          "/game/characters/attack-movies/14/frame-06.png",
          "/game/characters/attack-movies/14/frame-07.png",
          "/game/characters/attack-movies/14/frame-02.png",
          "/game/characters/attack-movies/14/frame-01.png",
          "/game/characters/attack-movies/14/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/14/frame-01.png",
              "/game/characters/attack-movies/14/frame-02.png",
              "/game/characters/attack-movies/14/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/14/frame-04.png",
              "/game/characters/attack-movies/14/frame-05.png",
              "/game/characters/attack-movies/14/frame-06.png",
              "/game/characters/attack-movies/14/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/14/frame-02.png",
              "/game/characters/attack-movies/14/frame-01.png",
              "/game/characters/attack-movies/14/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie14",
        "sourceCharacterId": 97,
        "sourceChildSymbol": "14_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/14.swf",
        "sourceSha256": "4251f65b3c68b38216b1b0584d323ecc0b965592b5813fa0170e367af43c7a93",
        "frameSha256": [
          "7a79a03d4971facb6460ad09fb94658639357c3e5f6e791f1beb0ab7df58d680",
          "1fa69585bbbbe4e1392362bc75fc3051d62af19a3b16c3157918c9323f0a81bd",
          "6bec304e1e3bb49480c2cfcda65ed45d15e4736c3f83cda004bc7336e6817df2",
          "898f255c4a130e4455ebb408b972305a0947a1a8fd6666f6a98d92dbf7fefd8e",
          "2702a20f50999ba9ed62317f536a288c7114ed1ac0d9fafb83a4cab863d89be1",
          "978daffae9f0e956678fa66465192252dea5f877f6f83a09fac4ac871840004f",
          "a748cfb1134ebb078324d4d6ffa7a25108a7d1968bd2c7d2295dc27fc0408c72",
          "1fa69585bbbbe4e1392362bc75fc3051d62af19a3b16c3157918c9323f0a81bd",
          "7a79a03d4971facb6460ad09fb94658639357c3e5f6e791f1beb0ab7df58d680",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "141",
        "vectorFrameSha256": [
          "c42bb3fb30da64a717487a9250c679c1d500fab960880acf9e2cd75b1f156117",
          "b26ccdf4e583be6a74221c3ae679472c1bbbeaaaf5aab83eae25fb0a68a6b7ae",
          "28eefa6416e76ac3d9dab543b1df3bedf4490c8d06e9a3bb5a27c69d9b816a53",
          "596c6221fd4078e9c32e156f36cc572a87a07067360ca0a9632b4094ae39f283",
          "e5d99cec7f0133202fc785375fc9bfd49c683a78d7dee09e4670b6b3998f2f27",
          "70729dccc7d1faca47de600e51df37159332e3ab09575f2a7554ea9921bfd7eb",
          "7eee7c2a4777a2fb631a990a4f0563e06806ef7445d294176d11cbe4bcce9a03",
          "b26ccdf4e583be6a74221c3ae679472c1bbbeaaaf5aab83eae25fb0a68a6b7ae",
          "c42bb3fb30da64a717487a9250c679c1d500fab960880acf9e2cd75b1f156117",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/15/frame-01.png",
          "/game/characters/attack-movies/15/frame-02.png",
          "/game/characters/attack-movies/15/frame-03.png",
          "/game/characters/attack-movies/15/frame-04.png",
          "/game/characters/attack-movies/15/frame-05.png",
          "/game/characters/attack-movies/15/frame-06.png",
          "/game/characters/attack-movies/15/frame-07.png",
          "/game/characters/attack-movies/15/frame-02.png",
          "/game/characters/attack-movies/15/frame-01.png",
          "/game/characters/attack-movies/15/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/15/frame-01.png",
              "/game/characters/attack-movies/15/frame-02.png",
              "/game/characters/attack-movies/15/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/15/frame-04.png",
              "/game/characters/attack-movies/15/frame-05.png",
              "/game/characters/attack-movies/15/frame-06.png",
              "/game/characters/attack-movies/15/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/15/frame-02.png",
              "/game/characters/attack-movies/15/frame-01.png",
              "/game/characters/attack-movies/15/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie15",
        "sourceCharacterId": 99,
        "sourceChildSymbol": "15_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/15.swf",
        "sourceSha256": "2e01bd1734139833457cfc415b74155ac966e9436d3c0add1b738d638b755a64",
        "frameSha256": [
          "d8ddf99ad69f2584402bfba6b84beecc3a18fda54aa79aae1e57b9ce034926f1",
          "6756feb8b5266f34d8736c5e1a2a1ce26ed6f18909a6eaa0914aabb5058e972e",
          "7a98f4c2d51133e4a6d959647d38d33e7e4b6a4f8dbd316a4b1c90eda436f67d",
          "38b6a1920e81d682d2d52862bd2974288c0183b547b8399bccd47e6d3115dd82",
          "c17d9ed02422c7ce6940c7ab13ad7257ecb3307b711aa1a960811eb7c97af5ac",
          "67d6e328bcbc7ab3dab400e489f9f424ec307338ff2611f7e508cab3732c25bc",
          "dd513778f972ca3f2521d1d94449aaf2c640fd047d2022f05c7144090755c71f",
          "6756feb8b5266f34d8736c5e1a2a1ce26ed6f18909a6eaa0914aabb5058e972e",
          "d8ddf99ad69f2584402bfba6b84beecc3a18fda54aa79aae1e57b9ce034926f1",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "151",
        "vectorFrameSha256": [
          "62ec71df48406ce07a874a71c15a0d57a999cf35bb8a91430d7f41afdfa22f3a",
          "f4a49f2ed235ef6082fae7d9b34e1d82e69c57873af6be52fc6c00998bf327d1",
          "89df6d2b9d6404213923640c053ad9ad72de3648345fc5bb830af760dc5961c6",
          "7e37201d44d6ede323643f7eed6c49f024d21ca26f72d943aa824b9f62fa12fa",
          "f4867ab5e13b044b76538370c47f996436c9584b29cffee54708fe6685ad466e",
          "69ae10d062a6c72f77fd13063162cb42437d5a0df4ac21c11712378c6cfee03d",
          "6f05e5185593e9fbcd8aef59f67e404ed78f4dddf714feec4bfc79b7ee17b7e7",
          "f4a49f2ed235ef6082fae7d9b34e1d82e69c57873af6be52fc6c00998bf327d1",
          "62ec71df48406ce07a874a71c15a0d57a999cf35bb8a91430d7f41afdfa22f3a",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      }
    },
    "brick": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/38/frame-01.png",
          "/game/characters/attack-movies/38/frame-02.png",
          "/game/characters/attack-movies/38/frame-03.png",
          "/game/characters/attack-movies/38/frame-04.png",
          "/game/characters/attack-movies/38/frame-05.png",
          "/game/characters/attack-movies/38/frame-06.png",
          "/game/characters/attack-movies/38/frame-07.png",
          "/game/characters/attack-movies/38/frame-08.png",
          "/game/characters/attack-movies/38/frame-02.png",
          "/game/characters/attack-movies/38/frame-01.png",
          "/game/characters/attack-movies/38/frame-08.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/38/frame-01.png",
              "/game/characters/attack-movies/38/frame-02.png",
              "/game/characters/attack-movies/38/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/38/frame-04.png",
              "/game/characters/attack-movies/38/frame-05.png",
              "/game/characters/attack-movies/38/frame-06.png",
              "/game/characters/attack-movies/38/frame-07.png",
              "/game/characters/attack-movies/38/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/38/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie38",
        "sourceCharacterId": 9,
        "sourceChildSymbol": "_38_fla._1_12",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/38.swf",
        "sourceSha256": "684286f35d350caaa0bd536034db800885fbf4918668b47ce21469ad0e59c2fa",
        "frameSha256": [
          "a40889e7d6c2d4181b42078ae3b25c49bff23dc4398687387419c95a7b1894f3",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "91438d3f1246e1d85d80fa63ed0280d3235b047301f15af4d70cd9cf80e6af7b",
          "1290ecfcde5022ff79c5e850d80926861f1f06c8ba78cbb0131ab8a22163c89c",
          "24445779edb6cd56719e9ace34c5ae89f6c3c6f25688a6a58c55ed6714bc4deb",
          "fa6abafa90fbc4d1b3608dc8e87473fbaf8a282db272e86fc7ea037e7aed346e",
          "ca9f48681508a99c13f4c08fd8be0ccd137d67ccf361b8aad59b248f6d238f55",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "a40889e7d6c2d4181b42078ae3b25c49bff23dc4398687387419c95a7b1894f3",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "381",
        "vectorFrameSha256": [
          "e0d9d0bef8409806d93b261f284e84fb7dbaf64c39b554aa06a43023c6323193",
          "537dff851d2d215b290f3df5fd3f0397e9c4e4bf34a4d0b37d03fe54ae6b597c",
          "23c811f9d57aa485f1e2573010eb43f71638b4789e52af9dbf47b47001636438",
          "26a26908d95dfdcb71289eea95e65bb9e76465fef676313bc3d260c4f4c011f2",
          "aa4db3328f93b24d62a3c2b331d297bf3c9a138e7bb2c911a39b597aa2b55008",
          "f594455e32669070bad325687a9e7dd01a4bad82e8ad2f8a5c2a196f2615baa8",
          "1787a10f3ebfd9820c4e8680ebcd2584dbc5323e83e8ccb9e7369712ad381b7f",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4",
          "537dff851d2d215b290f3df5fd3f0397e9c4e4bf34a4d0b37d03fe54ae6b597c",
          "e0d9d0bef8409806d93b261f284e84fb7dbaf64c39b554aa06a43023c6323193",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/39/frame-01.png",
          "/game/characters/attack-movies/39/frame-02.png",
          "/game/characters/attack-movies/39/frame-03.png",
          "/game/characters/attack-movies/39/frame-04.png",
          "/game/characters/attack-movies/39/frame-05.png",
          "/game/characters/attack-movies/39/frame-06.png",
          "/game/characters/attack-movies/39/frame-07.png",
          "/game/characters/attack-movies/39/frame-08.png",
          "/game/characters/attack-movies/39/frame-09.png",
          "/game/characters/attack-movies/39/frame-10.png",
          "/game/characters/attack-movies/39/frame-08.png"
        ],
        "width": 134,
        "height": 95,
        "anchor": {
          "x": 19,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/39/frame-01.png",
              "/game/characters/attack-movies/39/frame-02.png",
              "/game/characters/attack-movies/39/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/39/frame-04.png",
              "/game/characters/attack-movies/39/frame-05.png",
              "/game/characters/attack-movies/39/frame-06.png",
              "/game/characters/attack-movies/39/frame-07.png",
              "/game/characters/attack-movies/39/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/39/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie39",
        "sourceCharacterId": 11,
        "sourceChildSymbol": "_39_fla._1_12",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/39.swf",
        "sourceSha256": "489754ed209a3dc1f694ba1ee9e1fd5c39464579fa0f202a30a42dc1ddfbdde0",
        "frameSha256": [
          "1dd7524859d0d8282cf9e6cc0b2caa6b409251e60b286e3f6e5ec8eff4092ce1",
          "69858eb24e6bd31e729a4dd8137e822ab898614a5ab8ce6eb405d829c29c4820",
          "e85fac339f3d04e5e828f52dc85a6079d14b01691516b3b1a8f1bad19d5783c3",
          "cee05e8718a37ccd89ddc96af8688a3d1ed816abc62a4613292497621d1f2c74",
          "dae57ea602c1eb19d2b785c97d85ee9dd31731b1dfa5f2ab5beb4c63bda50b4c",
          "5408dc1f8b8926c38de2e11da5d8a665b536c0ac4482fa57248bc1198e0a356c",
          "8de6c280b2075130cba0264d2b1509bbfcd8ae73646d61ffef30e822533e94ed",
          "56947e0ddb6f1350c93755b7628a210ba3f16e0c74427bfacd6673644fd0c731",
          "69858eb24e6bd31e729a4dd8137e822ab898614a5ab8ce6eb405d829c29c4820",
          "1dd7524859d0d8282cf9e6cc0b2caa6b409251e60b286e3f6e5ec8eff4092ce1",
          "56947e0ddb6f1350c93755b7628a210ba3f16e0c74427bfacd6673644fd0c731"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "391",
        "vectorFrameSha256": [
          "b4a1ff12241200f906e56bd09c4b16d663fe6005cb13d15504209249e78efeac",
          "0dede6769095e528804c3155b4aaade7729eb9e71dbabfcb1a75f7f9a9f97484",
          "53577202a4ac762fcd49006023eb05e4b6b621a584572e5d69dfc592b0d04cc1",
          "4965131700e0994f246ca697fb973e74666cbb26c36905568fe4366169876e62",
          "3df8fd7fcec31f3beb1337b972404ee9ece7a6095f83bdd401ba4b2462a730fe",
          "1c105de12569886c79c64851321a043c0986a73958fe6cbf7e0f9a42d529239e",
          "305ac3aaf08b5f444e68bf328aa7e03c3b9c150d473c9246ee4146f3cd1a3bb1",
          "d4a9bb25f993005a23b9290e23cedfaa643e44cf55adbe68960006b8ace0074f",
          "810b6eaf0287165d4a7fb28a5036e17956c070d36aa91ddcb462dae1027898c2",
          "d184025903d83197ff761d62ffcface966bd3e017ab2a29b3a7b725b75e9b642",
          "d4a9bb25f993005a23b9290e23cedfaa643e44cf55adbe68960006b8ace0074f"
        ]
      }
    },
    "fruit": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/40/frame-01.png",
          "/game/characters/attack-movies/40/frame-02.png",
          "/game/characters/attack-movies/40/frame-03.png",
          "/game/characters/attack-movies/40/frame-04.png",
          "/game/characters/attack-movies/40/frame-05.png",
          "/game/characters/attack-movies/40/frame-06.png",
          "/game/characters/attack-movies/40/frame-07.png",
          "/game/characters/attack-movies/40/frame-08.png",
          "/game/characters/attack-movies/40/frame-02.png",
          "/game/characters/attack-movies/40/frame-01.png",
          "/game/characters/attack-movies/40/frame-08.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/40/frame-01.png",
              "/game/characters/attack-movies/40/frame-02.png",
              "/game/characters/attack-movies/40/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/40/frame-04.png",
              "/game/characters/attack-movies/40/frame-05.png",
              "/game/characters/attack-movies/40/frame-06.png",
              "/game/characters/attack-movies/40/frame-07.png",
              "/game/characters/attack-movies/40/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/40/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie40",
        "sourceCharacterId": 71,
        "sourceChildSymbol": "_40_fla._1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/40.swf",
        "sourceSha256": "7121f43343b60daad383091fb9c31e9e8cfc0a7b02a1cb540692d320c226657e",
        "frameSha256": [
          "a11a6f7894d5b71d84c0230cf31963fc629466bfaaa0b36939e99e5e39d68a1e",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "4af1aa89528cbec37e2b11b42234fe144d247a53a971cfb53a1a84b3961cd93f",
          "e2c7743252d3df03932e39da7e485a8db235541e54db760313ec5ec990d23000",
          "fdc2ce11a7dd52e536dd26cfea2405a0a1f6f5f8d0f1f2e7de725ec123e4cde6",
          "7c0859fc1b0df4bc031e58f9f1512939943895c3fbd3c74e8191350a7705c3c8",
          "a908f6136eda191fd14f62fe0654daf91e70487058341179642ce745e37d6fa6",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "a11a6f7894d5b71d84c0230cf31963fc629466bfaaa0b36939e99e5e39d68a1e",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "401",
        "vectorFrameSha256": [
          "fa719070ebe702b8f4505901cb7681a8154c87137020d56b763f8669c904a32a",
          "93dfcaa07c46b469abe26eac5777ded54069a6d98ef7c2b2c6dd04c9e716b160",
          "4ddb47a872bd0b42c711bc30ae7aa314994958eac6b0b752d3f3e7b9ef970222",
          "567387b7be4dabbd8c037e8b1ae88f3b2420e3a0da88dc9c2ca9e2ea8a33c8d8",
          "118cdcf91ef39ca372758c139ea5f3419ffc5b72fd49ef96c75bc2da6ab97b37",
          "62329fc4b2e412fbb707f08ef4d57fa83fd6e5b0302ba5197b6e10d2ac3bb1d6",
          "f513d8b5067af892a619c6dc1000dcdb45ae030fad47bca4f3f54411e71d5942",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4",
          "93dfcaa07c46b469abe26eac5777ded54069a6d98ef7c2b2c6dd04c9e716b160",
          "fa719070ebe702b8f4505901cb7681a8154c87137020d56b763f8669c904a32a",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/41/frame-01.png",
          "/game/characters/attack-movies/41/frame-02.png",
          "/game/characters/attack-movies/41/frame-03.png",
          "/game/characters/attack-movies/41/frame-04.png",
          "/game/characters/attack-movies/41/frame-05.png",
          "/game/characters/attack-movies/41/frame-06.png",
          "/game/characters/attack-movies/41/frame-07.png",
          "/game/characters/attack-movies/41/frame-08.png",
          "/game/characters/attack-movies/41/frame-02.png",
          "/game/characters/attack-movies/41/frame-01.png",
          "/game/characters/attack-movies/41/frame-08.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/41/frame-01.png",
              "/game/characters/attack-movies/41/frame-02.png",
              "/game/characters/attack-movies/41/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/41/frame-04.png",
              "/game/characters/attack-movies/41/frame-05.png",
              "/game/characters/attack-movies/41/frame-06.png",
              "/game/characters/attack-movies/41/frame-07.png",
              "/game/characters/attack-movies/41/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/41/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie41",
        "sourceCharacterId": 9,
        "sourceChildSymbol": "_41_fla.Timeline_12",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/41.swf",
        "sourceSha256": "f4caf58160d4756bd976977b86690489196e11d29a8a1bab8af9adfe8c38963c",
        "frameSha256": [
          "2441aadc0fd7b2804187badb80fd35b2692b14c3eda454661beefe47d8ed3db8",
          "c3fb0699efd09ddfdf497a800c78edfb0cb9ea246293d790844a25084bc50dd4",
          "8399cf2408f07853f93c77300a874dd8e8214032e9db666c10a6ff9eeae4f9be",
          "33e6433b8d4eb4f1599f57a4af62888873f825907dd44287535269db87631355",
          "d97b48adfbe8b70182ca265a42c8cc8e2d250b759b27ae92b8ab7ef5f8114f53",
          "2d43245ee9d6242ae2e3466e909d99da7e8b70dd1ade26a75e693239ee246ec9",
          "7d3f5c86d0c3fa463cc538c68bd30665ad6839c1a5a2129070a5e33b54efc616",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc",
          "c3fb0699efd09ddfdf497a800c78edfb0cb9ea246293d790844a25084bc50dd4",
          "2441aadc0fd7b2804187badb80fd35b2692b14c3eda454661beefe47d8ed3db8",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "411",
        "vectorFrameSha256": [
          "caf3da26bf1eed4c14c5f6288ff89a4b73163b058955a96fac7fd43c4527ab28",
          "c6f92db8f4d3eaa8bbe88723144688631694abc89f03ebd78a0541866933fc7f",
          "858a61ffed847a91fbd64c7c1d97a18e18f4c9d0fe173463bdbb196616080acf",
          "061a51a1c9cfa891c6b1bd2632ade22a412eb118af39b8a4ea1af6a8f27ebf59",
          "de1049817bfea78a168d46f2af40f6fc7e0cfbc62216fd6a0c39a4d05533ef3f",
          "a3ce309b4005fc105ede3c8c6e9af19adde802c09ba684eab3d175f9fb0a9d30",
          "3900b0ce7a89855858b441a2661b4ee9dcc481422db320f3132bf7b14304fbca",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4",
          "c6f92db8f4d3eaa8bbe88723144688631694abc89f03ebd78a0541866933fc7f",
          "caf3da26bf1eed4c14c5f6288ff89a4b73163b058955a96fac7fd43c4527ab28",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      }
    },
    "OPSbox": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/34/frame-01.png",
          "/game/characters/attack-movies/34/frame-02.png",
          "/game/characters/attack-movies/34/frame-03.png",
          "/game/characters/attack-movies/34/frame-04.png",
          "/game/characters/attack-movies/34/frame-05.png",
          "/game/characters/attack-movies/34/frame-06.png",
          "/game/characters/attack-movies/34/frame-07.png",
          "/game/characters/attack-movies/34/frame-08.png",
          "/game/characters/attack-movies/34/frame-02.png",
          "/game/characters/attack-movies/34/frame-01.png",
          "/game/characters/attack-movies/34/frame-08.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/34/frame-01.png",
              "/game/characters/attack-movies/34/frame-02.png",
              "/game/characters/attack-movies/34/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/34/frame-04.png",
              "/game/characters/attack-movies/34/frame-05.png",
              "/game/characters/attack-movies/34/frame-06.png",
              "/game/characters/attack-movies/34/frame-07.png",
              "/game/characters/attack-movies/34/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/34/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie34",
        "sourceCharacterId": 9,
        "sourceChildSymbol": "_34_fla._1_12",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/34.swf",
        "sourceSha256": "25d1dbacefa8787cd78fff804157e76e8f9f2a3b372c1952a3ae7d0cbe0a1a26",
        "frameSha256": [
          "bc42d63d020c64b14b25a422d2fa290a8f5a4c6bd0e4cc318552c300a7ec6865",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "9dfd2f328040cacba9051127a569ceeec85cfa7aad100e2d2ebd3f9bc17061a3",
          "6da81a27af3009e1fc51ba7cc50e44a0eb0e081ee77665d889a28b0839ecd5b0",
          "0ea0e200f0c185d2974e6679f662157e7e53c500765431659fdd5bed3e264dbd",
          "c3baebdda21d8f2f25e8862672c45018f9323039852163febae8b9fd65dd5b37",
          "2ff0f0402ce8ce49e780f7f1b3c43e2b6f99fe13199be092290ce5949b88afe3",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "bc42d63d020c64b14b25a422d2fa290a8f5a4c6bd0e4cc318552c300a7ec6865",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "341",
        "vectorFrameSha256": [
          "52317ac51db870cce4e1e59787e8349f58fc0754b3ce3bce76e66c9d2baf55ca",
          "ad3b87f80aa85fb6a101ae27001189ad3c775f463a240f067949eb1b87b098a4",
          "53872774aba048e3761f67fa815e1bf0ee44ef5abbbf73d20742a667754fb5c3",
          "697eb7c6196100d5c5efff71e595e9a19cc268cc15a14592b0c26f785fd3561a",
          "39ef954804172732ae14c7713dedf227c403487eb5423328d50f8a446332d6f9",
          "86fb1c777e5df1cdabe0f59a39d57b29ca9d1f4832f29b446449f085c0a3cd46",
          "07258030759010ec4381d16d631c2a543d0c3e713225f8b9ee8052ec50f7be94",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4",
          "ad3b87f80aa85fb6a101ae27001189ad3c775f463a240f067949eb1b87b098a4",
          "52317ac51db870cce4e1e59787e8349f58fc0754b3ce3bce76e66c9d2baf55ca",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/35/frame-01.png",
          "/game/characters/attack-movies/35/frame-02.png",
          "/game/characters/attack-movies/35/frame-03.png",
          "/game/characters/attack-movies/35/frame-04.png",
          "/game/characters/attack-movies/35/frame-05.png",
          "/game/characters/attack-movies/35/frame-06.png",
          "/game/characters/attack-movies/35/frame-07.png",
          "/game/characters/attack-movies/35/frame-08.png",
          "/game/characters/attack-movies/35/frame-02.png",
          "/game/characters/attack-movies/35/frame-01.png",
          "/game/characters/attack-movies/35/frame-08.png"
        ],
        "width": 126,
        "height": 95,
        "anchor": {
          "x": 11,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/35/frame-01.png",
              "/game/characters/attack-movies/35/frame-02.png",
              "/game/characters/attack-movies/35/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/35/frame-04.png",
              "/game/characters/attack-movies/35/frame-05.png",
              "/game/characters/attack-movies/35/frame-06.png",
              "/game/characters/attack-movies/35/frame-07.png",
              "/game/characters/attack-movies/35/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/35/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie35",
        "sourceCharacterId": 9,
        "sourceChildSymbol": "_35_fla._1_12",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/35.swf",
        "sourceSha256": "b5d173c9fe0f44060306f7deee0c3c29254eba706bb167fafc7948f0356b2fba",
        "frameSha256": [
          "3eaccb79868c1a82ebe3c95ac88b8f0c5883e6e480e085126a9d0a29a9ac5504",
          "d16654cfc29d30b1ce67f66da380322ce530e3ac56135ff53842f6f1e198c4a7",
          "280bae01afe802f02455d4368fb85e79471d73bdd98a4735658d5da0762b4431",
          "0930632b592d5a5aa647d37e6d5a86d56ed5ffc5ed062724ecfa9d185851aa9e",
          "9bc1254adf07550f9e7de5557e276e04df95e1b4e58802e7a7c1687bc9fd184e",
          "5cf1ac59f47ba1625085c1edaaf417c758d00888b72e806b40af7af2a5ba648c",
          "86ecb3d79c18b4c88db97291033ee2405d04a358e13fa62ebe939d1de4741b00",
          "52c39db0c2972bdf224aa09cabdd8e8d75d2f0199af409e4c21bbabb9661c061",
          "d16654cfc29d30b1ce67f66da380322ce530e3ac56135ff53842f6f1e198c4a7",
          "3eaccb79868c1a82ebe3c95ac88b8f0c5883e6e480e085126a9d0a29a9ac5504",
          "52c39db0c2972bdf224aa09cabdd8e8d75d2f0199af409e4c21bbabb9661c061"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "351",
        "vectorFrameSha256": [
          "e73862dc8ade1df6c93a8cb0709f8b7064df8072895402fda57b118aa8cc8287",
          "87f1dc40ee2fb1c2e86e63ceef5ac401e82f3e3ead075cde91048042b6016ccd",
          "f50a382236908783ea80779d5423741f5dc48612f7d8667c61e17d28326cc8c9",
          "540be8cad608fdbd45159e5295d96c20f26127ba739e6e9fa17a261d0d92a782",
          "ccd8ebd8243f5066056deb40b633a8d041e959de2c282d28244a9cc81315ca22",
          "957094a87aa0c3cc888ff9b5ff49a8216f302d00575132196dacf1d763d3c127",
          "227d7812729719c1ac933572ee253c300ad9932de90f2d87ec12a2763589a143",
          "9890e41c92a9a3779f38ae06242fda43ac6f2bfe641150d77a685e498f8e8fea",
          "87f1dc40ee2fb1c2e86e63ceef5ac401e82f3e3ead075cde91048042b6016ccd",
          "e73862dc8ade1df6c93a8cb0709f8b7064df8072895402fda57b118aa8cc8287",
          "9890e41c92a9a3779f38ae06242fda43ac6f2bfe641150d77a685e498f8e8fea"
        ]
      }
    },
    "closestool": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/36/frame-01.png",
          "/game/characters/attack-movies/36/frame-02.png",
          "/game/characters/attack-movies/36/frame-03.png",
          "/game/characters/attack-movies/36/frame-04.png",
          "/game/characters/attack-movies/36/frame-05.png",
          "/game/characters/attack-movies/36/frame-06.png",
          "/game/characters/attack-movies/36/frame-07.png",
          "/game/characters/attack-movies/36/frame-02.png",
          "/game/characters/attack-movies/36/frame-01.png",
          "/game/characters/attack-movies/36/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/36/frame-01.png",
              "/game/characters/attack-movies/36/frame-02.png",
              "/game/characters/attack-movies/36/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/36/frame-04.png",
              "/game/characters/attack-movies/36/frame-05.png",
              "/game/characters/attack-movies/36/frame-06.png",
              "/game/characters/attack-movies/36/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/36/frame-02.png",
              "/game/characters/attack-movies/36/frame-01.png",
              "/game/characters/attack-movies/36/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie36",
        "sourceCharacterId": 75,
        "sourceChildSymbol": "36_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/36.swf",
        "sourceSha256": "f9d142ab7dc765d5fc760f76ff15fb33a0bd4aa590ebbf858dabbd8a00297c9e",
        "frameSha256": [
          "cb75c4626219edbbeaaebbcf2b70d7311d8f03d976eb27e68e0fe777d459b7f7",
          "9ea1ab7680b442097bc0f0666f314368cee5bef8033496841cfebd94236c8145",
          "faeb3e2757bcbf0b7e7a03c4349d6ad8f54dd7ca93538234e6117831eef7d4ea",
          "2dc367ea44478551a8da474b8243eb42ec52e23d5751ef5e31c934cacdf600e9",
          "363e1527ec743277e28dec12b8d7e8574e8c1c7a474884edfdfa8581e8949b19",
          "3ff0261d98bcd325b440d8d444574edd931725af7d564fc5227557ea1c0baa7e",
          "410274aec58cffb81157b4bf2321eca601838f149e119710b0be2a4126b420f2",
          "9ea1ab7680b442097bc0f0666f314368cee5bef8033496841cfebd94236c8145",
          "cb75c4626219edbbeaaebbcf2b70d7311d8f03d976eb27e68e0fe777d459b7f7",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "361",
        "vectorFrameSha256": [
          "8ab42215e541b8d6996657956422bfdc8d5e5255da27e5eae55ab435fc22a46c",
          "047498cbffb7d14409f636167736d8319e0283d3da8a83ea26e261c1422c4928",
          "de580c2350e1fb4a76b29d15472667b162b1cb6faa296d25843638753995bfd0",
          "9df18be87fcbfef2b472b04376e55add8bd311121df075aee5be73c1d44b0d14",
          "1317f9f6641b46ece3c758ec0d46270d3d1bf8d5fc23e43822aa988c5dd949bc",
          "65b82de0885511af038d1d2524bd61aec68ba9d147104de468c37309b16810e2",
          "54f64ef2f5237e45ed2fcc1d189e75f033487106404c4f81b2ab63a9536b529c",
          "047498cbffb7d14409f636167736d8319e0283d3da8a83ea26e261c1422c4928",
          "8ab42215e541b8d6996657956422bfdc8d5e5255da27e5eae55ab435fc22a46c",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/37/frame-01.png",
          "/game/characters/attack-movies/37/frame-02.png",
          "/game/characters/attack-movies/37/frame-03.png",
          "/game/characters/attack-movies/37/frame-04.png",
          "/game/characters/attack-movies/37/frame-05.png",
          "/game/characters/attack-movies/37/frame-06.png",
          "/game/characters/attack-movies/37/frame-07.png",
          "/game/characters/attack-movies/37/frame-02.png",
          "/game/characters/attack-movies/37/frame-01.png",
          "/game/characters/attack-movies/37/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 12,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/37/frame-01.png",
              "/game/characters/attack-movies/37/frame-02.png",
              "/game/characters/attack-movies/37/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/37/frame-04.png",
              "/game/characters/attack-movies/37/frame-05.png",
              "/game/characters/attack-movies/37/frame-06.png",
              "/game/characters/attack-movies/37/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/37/frame-02.png",
              "/game/characters/attack-movies/37/frame-01.png",
              "/game/characters/attack-movies/37/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie37",
        "sourceCharacterId": 72,
        "sourceChildSymbol": "37_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/37.swf",
        "sourceSha256": "01a752b89ce1470e68b21118066fbdb8bb6a81ce898326fc04bd69d7d63816ae",
        "frameSha256": [
          "506cd1171398bc4ee657d2c119000379439a2644d23231b9b8a99dde77eebc3c",
          "ce3e1ae5f4a9c7787855c36c5e42ecd9f4c92e99834ec02136f7763e6452336d",
          "dd93b538b628725fdc987cb3b62ed74c526d3ba8a3fc672e27526c08adfd184c",
          "bf9bc7b92c8887fc743ec7263575903172808a64f6d7d2d2eea0016f70a631a0",
          "a87795051053ab23a827ffffa0097a6ceaef9adf3c10bd4e838b69352f0f84e2",
          "1fd692d5bf07a9ec1c62f92206520f685d6c19b5b8a2c0981f90022539257c56",
          "8559aa69feb008bc2a548ef9c2edc6bc96c4f51c5836b6c454657a7586280e9f",
          "ce3e1ae5f4a9c7787855c36c5e42ecd9f4c92e99834ec02136f7763e6452336d",
          "506cd1171398bc4ee657d2c119000379439a2644d23231b9b8a99dde77eebc3c",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "371",
        "vectorFrameSha256": [
          "7ac88b84ad40fe5b5d3ae10751829d96bd3659d027828fc2a8b1c0b45651166b",
          "490a3d6a86f73c2ad1a710e05bf9a2142ca1b4c913fe1b44ed6778e1a266e74a",
          "535ef07019d95a415829aa834b0088fa586b5f397c4e64a05378bc791d0c3d00",
          "5487a9d4b8e9170579f42f069e069308ad0c5299cb9eeadf157113b8086a4017",
          "2477b21514d503660dbec9a76d66638ed052cbc59b5df26350891a57cb91afd6",
          "28f4f842e1128861ae91dc98faba1055822dbaa92d3a7508eb86ee972d06b38f",
          "2d66fcf9a99166237420c145e21852c1c93b9c83e04ad1f725fbd8605be80d3e",
          "490a3d6a86f73c2ad1a710e05bf9a2142ca1b4c913fe1b44ed6778e1a266e74a",
          "7ac88b84ad40fe5b5d3ae10751829d96bd3659d027828fc2a8b1c0b45651166b",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      }
    },
    "television": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/32/frame-01.png",
          "/game/characters/attack-movies/32/frame-02.png",
          "/game/characters/attack-movies/32/frame-03.png",
          "/game/characters/attack-movies/32/frame-04.png",
          "/game/characters/attack-movies/32/frame-05.png",
          "/game/characters/attack-movies/32/frame-06.png",
          "/game/characters/attack-movies/32/frame-07.png",
          "/game/characters/attack-movies/32/frame-08.png",
          "/game/characters/attack-movies/32/frame-02.png",
          "/game/characters/attack-movies/32/frame-01.png",
          "/game/characters/attack-movies/32/frame-08.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/32/frame-01.png",
              "/game/characters/attack-movies/32/frame-02.png",
              "/game/characters/attack-movies/32/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/32/frame-04.png",
              "/game/characters/attack-movies/32/frame-05.png",
              "/game/characters/attack-movies/32/frame-06.png",
              "/game/characters/attack-movies/32/frame-07.png",
              "/game/characters/attack-movies/32/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/32/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie32",
        "sourceCharacterId": 75,
        "sourceChildSymbol": "_32_fla._1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/32.swf",
        "sourceSha256": "446dee0cb208d865d7a1d5d1fa3b9a062ebe0fd9b2a27b537b44b48afc702571",
        "frameSha256": [
          "f55abc1e2297232bf63b1be0ce25ab6ea2d7754316185eb7a5f476bd00e08a51",
          "7b49eff144f60ca02462d51eab319c43431e65ac75e24b4a95e30a276a6223f6",
          "fe59bd8a3baacd2e7a187b64a170365ca29d921a0a8433681cbde07c164ec763",
          "bb83f23a6571292825ea43bd0846cd9af79b01772b60a5f94ca0f5d956bad987",
          "5761f4ac3a4f81826c79d5d9f96837580dc9e897585ae355654849d79ed31f3f",
          "a7b41b6377f7955294a4bc506c2f2e0f5811cf3bf2f66f502cd73f5021ab0aa6",
          "5e8a5421eaccc8d2cb88713cf56e620ee4389e836201a2ea48d904f8e91ca45c",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc",
          "7b49eff144f60ca02462d51eab319c43431e65ac75e24b4a95e30a276a6223f6",
          "f55abc1e2297232bf63b1be0ce25ab6ea2d7754316185eb7a5f476bd00e08a51",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "321",
        "vectorFrameSha256": [
          "7a175be4707699386519b094847962edd08fcee59784256d49a0e0638f090586",
          "821ddb0fc73ed01dac6f64a6c19dd54cf2809ff854e35588bfacf30c15352b76",
          "013c30718f73930eb03395237b3bef8dc519721e1fa735996fab1549f19d6fc1",
          "76a218c39b3578b34db84e54f1a43f3530c6f29c7b8516cfa16bb10428431ad8",
          "c545184437fdfb7d6e46c93a403547b65a2027b165ba76bbf90aef99ee3076f0",
          "818ec9eb1f406a209032830b52cffd6358848aac1f8002e558b997d8918ca262",
          "d7f81cce1bf96ae42a98baddb31971da933317012f42e38d72f3496c16b21469",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4",
          "821ddb0fc73ed01dac6f64a6c19dd54cf2809ff854e35588bfacf30c15352b76",
          "7a175be4707699386519b094847962edd08fcee59784256d49a0e0638f090586",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/33/frame-01.png",
          "/game/characters/attack-movies/33/frame-02.png",
          "/game/characters/attack-movies/33/frame-03.png",
          "/game/characters/attack-movies/33/frame-04.png",
          "/game/characters/attack-movies/33/frame-05.png",
          "/game/characters/attack-movies/33/frame-06.png",
          "/game/characters/attack-movies/33/frame-07.png",
          "/game/characters/attack-movies/33/frame-08.png",
          "/game/characters/attack-movies/33/frame-02.png",
          "/game/characters/attack-movies/33/frame-01.png",
          "/game/characters/attack-movies/33/frame-08.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/33/frame-01.png",
              "/game/characters/attack-movies/33/frame-02.png",
              "/game/characters/attack-movies/33/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/33/frame-04.png",
              "/game/characters/attack-movies/33/frame-05.png",
              "/game/characters/attack-movies/33/frame-06.png",
              "/game/characters/attack-movies/33/frame-07.png",
              "/game/characters/attack-movies/33/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/33/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie33",
        "sourceCharacterId": 73,
        "sourceChildSymbol": "_33_fla._1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/33.swf",
        "sourceSha256": "15bd4d3f4786f81580201639ecac9d795ec1c4fed4a60720b3548a8407a9fbd3",
        "frameSha256": [
          "b2ac584e17b5fa4dfb0cd2c55d15e435224b717f8b646a9d952c8087b6510810",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "48a0a554947b7b2c88a24b162533337401b2e9949d984d4077ba8ea8d20b86af",
          "e91351cb2bab419585c4cbc4d61167044da2da6358b7de441664fa3c0bb5a962",
          "703e1bc202fde4dd5b58a3c466ffa8e1c90020861beafa05e8779c4a768c134a",
          "fa99610c8a3585f54818e192fd5ddf20f841ada241fefbd4d1f91129fb47f23c",
          "542db759a767770d35fa965a6ffe678deff1957d639fbeb9ee4a31e9655d4a6c",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc",
          "f7699c4281a5ea403226b4b3d267e8cb3dd92333df49175243435c859ee0f8ed",
          "b2ac584e17b5fa4dfb0cd2c55d15e435224b717f8b646a9d952c8087b6510810",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "331",
        "vectorFrameSha256": [
          "8b0291421149f1dc110e0a6e9699c67332415a623d6b58f36254ba454ebc2453",
          "7e95f85d5347091ca5d37e7d7fdced311e1766d8a45c623637a4590f9e2301a9",
          "f14c40e36c54e5518169ec9eb32cf6c98dcb1d5ed642ab21f594a998ae7ad05f",
          "607f593d855c567bba242db35216ef2d340dcc08e0587f6a087e41b219cc1574",
          "e3f93a208770307cb72d0920ab5515a408b349b6d8b250f1987f05d01d0384cd",
          "b75d2ed87e52dfa2855d08ca3301c741c1f8db514db5cbab29c4bbb315d224a8",
          "845a5a748ee079188e10ca36d4d8922adcfa03c01d2ef303f7d43437bb1ce27f",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4",
          "7e95f85d5347091ca5d37e7d7fdced311e1766d8a45c623637a4590f9e2301a9",
          "8b0291421149f1dc110e0a6e9699c67332415a623d6b58f36254ba454ebc2453",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      }
    },
    "axe": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/20/frame-01.png",
          "/game/characters/attack-movies/20/frame-02.png",
          "/game/characters/attack-movies/20/frame-03.png",
          "/game/characters/attack-movies/20/frame-04.png",
          "/game/characters/attack-movies/20/frame-05.png",
          "/game/characters/attack-movies/20/frame-06.png",
          "/game/characters/attack-movies/20/frame-07.png",
          "/game/characters/attack-movies/20/frame-08.png",
          "/game/characters/attack-movies/20/frame-02.png",
          "/game/characters/attack-movies/20/frame-01.png",
          "/game/characters/attack-movies/20/frame-08.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/20/frame-01.png",
              "/game/characters/attack-movies/20/frame-02.png",
              "/game/characters/attack-movies/20/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/20/frame-04.png",
              "/game/characters/attack-movies/20/frame-05.png",
              "/game/characters/attack-movies/20/frame-06.png",
              "/game/characters/attack-movies/20/frame-07.png",
              "/game/characters/attack-movies/20/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/20/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie20",
        "sourceCharacterId": 55,
        "sourceChildSymbol": "20_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/20.swf",
        "sourceSha256": "9a2fb36cdd89b89ecc8364f9274ec4a147fc85bb48764e84745b176ffa4a48eb",
        "frameSha256": [
          "d9e3bf0019b1ac33a5ec9c145ac5100adde75866d01082aa5529e97d130b671f",
          "7b49eff144f60ca02462d51eab319c43431e65ac75e24b4a95e30a276a6223f6",
          "19ecdf00e29704452e1efd7644e58c0b684a365dbf2e43d845b55ad6daad2b89",
          "b7a0e3d969d29c317ab72bec5facf1ac9164f8ab6757f1d0a8ec66ddf29e2c6e",
          "bed21c2654f36f6ec8874f64fa9c85ff9a201dc895be80136f76570fed00cd63",
          "bae5bdddb561d5a3e210c50c59670a0068605c1f4db78be8799e4d5f0141d73d",
          "d32c8e4189176bdbedbfa297371863396b6bb5c205e2299b999650a42e31e544",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc",
          "7b49eff144f60ca02462d51eab319c43431e65ac75e24b4a95e30a276a6223f6",
          "d9e3bf0019b1ac33a5ec9c145ac5100adde75866d01082aa5529e97d130b671f",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "20",
        "vectorFrameSha256": [
          "40856682ce2f55cf75005eaf50c0a74bf1a1a128529161e1de1f4970edfc258a",
          "7f1a8708688dd2537085a15ac2134c48cd7e05f2560aaaf8455608d9222d2ab3",
          "9d4fd7dd00f24b25847751ce294f7f6c9fea79837c61ad749fca308789055a57",
          "27f76d34f2d0235fc41f241f3f3e30ad870885243689d5d09a976390a9b52a0a",
          "832b60ed70a30730916e0fd35f932ae74cf94f415b5c074d0b527014b0145595",
          "95e9f43eea664790df3dce3fa59974782abb2d3944a39ed92be75e9354d987b0",
          "3fcafff44ceca21a9e56ebaabfcf09d2bfec1831c0c9743d299591030b861105",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4",
          "7f1a8708688dd2537085a15ac2134c48cd7e05f2560aaaf8455608d9222d2ab3",
          "40856682ce2f55cf75005eaf50c0a74bf1a1a128529161e1de1f4970edfc258a",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/21/frame-01.png",
          "/game/characters/attack-movies/21/frame-02.png",
          "/game/characters/attack-movies/21/frame-03.png",
          "/game/characters/attack-movies/21/frame-04.png",
          "/game/characters/attack-movies/21/frame-05.png",
          "/game/characters/attack-movies/21/frame-06.png",
          "/game/characters/attack-movies/21/frame-07.png",
          "/game/characters/attack-movies/21/frame-08.png",
          "/game/characters/attack-movies/21/frame-09.png",
          "/game/characters/attack-movies/21/frame-01.png",
          "/game/characters/attack-movies/21/frame-08.png"
        ],
        "width": 132,
        "height": 95,
        "anchor": {
          "x": 17,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/21/frame-01.png",
              "/game/characters/attack-movies/21/frame-02.png",
              "/game/characters/attack-movies/21/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/21/frame-04.png",
              "/game/characters/attack-movies/21/frame-05.png",
              "/game/characters/attack-movies/21/frame-06.png",
              "/game/characters/attack-movies/21/frame-07.png",
              "/game/characters/attack-movies/21/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/21/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie21",
        "sourceCharacterId": 57,
        "sourceChildSymbol": "21_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/21.swf",
        "sourceSha256": "3bc0091737a6dd98545deb6c404938ca6b59c7639d6e5f4c305ce53e496dae08",
        "frameSha256": [
          "72b32c56c1417ba5f5dfed5ef58e9b2dd7c2e4d9bd0b06bdc2303ac5731d2b23",
          "4078664c29dabc2d0761f73ede2a211ef42ed11cd3c95f9351f8c6451fdf354e",
          "72087150b80cad2dad8e69887ae1389053db81d42d3b9e480bcbcaa8c8f2d983",
          "964fef9919b623de55fe522ff0445ca4d691ff4ce0e88457fd2d169098ac4135",
          "ab67a75e93ae0e6e5c6dc4a930359fc84fa332a63b527d55b5ca4e6ddb2f427a",
          "310b34fa093ea3a1444343203edb948228720b48c351236d016123d9325f1036",
          "df6329d63dca94946c274b371a6c4f9b210062bb6f864323a8fe6058800a31f0",
          "948a7b86dcfd9c99d4b78e0f59bbca1f77167aa0788311eb7d89dce186cb84a5",
          "d74445df1d37c76124b24797ae7923af59b54a99fe282f3ed0abfa3a3d3f63c8",
          "72b32c56c1417ba5f5dfed5ef58e9b2dd7c2e4d9bd0b06bdc2303ac5731d2b23",
          "948a7b86dcfd9c99d4b78e0f59bbca1f77167aa0788311eb7d89dce186cb84a5"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "21",
        "vectorFrameSha256": [
          "3bfb93429734141b667db2eb2df88e41ea71e478f9b672e8cc07f6c69967d2e0",
          "670dbc57f6fe2fda276f2c4f757082cf96bf04e04191a6b01efe81c934c71831",
          "a89194ecc24907e6b18fb3c4c6752b0c778a9a9df7264dc2845f06b131f8135b",
          "093010d4cf7b4581c92efa3e3af66c575fe2977972aab11b8d6358e2f0f5c2f1",
          "782c281f0cdf02c4028e9c6df9f6187729a92a9235438c60daac842efd26355e",
          "521c1878d491302a8ab6c05b4718503d3db65ff6d7329879791630562abeec3a",
          "2b0e8af91a0944f4cc7ee020dcc9ce6350c9d56d6a3d57be0f83932f6627332c",
          "df54e31626b42b3eb86b9b87925654e39e4e4136066a0b8fe28231e177e2c3bc",
          "7cd5677b17db8b95c574d3033ebbdc5fab5eb270419028125dc4a84d0827c072",
          "3bfb93429734141b667db2eb2df88e41ea71e478f9b672e8cc07f6c69967d2e0",
          "df54e31626b42b3eb86b9b87925654e39e4e4136066a0b8fe28231e177e2c3bc"
        ]
      }
    },
    "bow": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/18/frame-01.png",
          "/game/characters/attack-movies/18/frame-02.png",
          "/game/characters/attack-movies/18/frame-03.png",
          "/game/characters/attack-movies/18/frame-04.png",
          "/game/characters/attack-movies/18/frame-05.png",
          "/game/characters/attack-movies/18/frame-06.png",
          "/game/characters/attack-movies/18/frame-07.png",
          "/game/characters/attack-movies/18/frame-02.png",
          "/game/characters/attack-movies/18/frame-01.png",
          "/game/characters/attack-movies/18/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/18/frame-01.png",
              "/game/characters/attack-movies/18/frame-02.png",
              "/game/characters/attack-movies/18/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/18/frame-04.png",
              "/game/characters/attack-movies/18/frame-05.png",
              "/game/characters/attack-movies/18/frame-06.png",
              "/game/characters/attack-movies/18/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/18/frame-02.png",
              "/game/characters/attack-movies/18/frame-01.png",
              "/game/characters/attack-movies/18/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie18",
        "sourceCharacterId": 56,
        "sourceChildSymbol": "18_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/18.swf",
        "sourceSha256": "837493e74bf43f221da4360cb5432b0c1ec77039bd10fd30b80d06d6f65de3d3",
        "frameSha256": [
          "e95748580d064f1087ef90ae6930b9dfc704da258e01a3695e48829be176dd09",
          "0e52d99282a83b05c641301c32ce03e42a7b6f89f9556f70e26aa64575192c03",
          "3c9c6d191c341af6de3870787c488cc6434cbe14218229df0fbad8408529149d",
          "f4e8c82d8f4ecae4df558f07352a5e3e15de3a65157e1b30a90783ee46e3aef4",
          "16550833343f25942b6771897a9928cc0248381c041b228ce602736140b76d8e",
          "8f55588f8710715e9f540f43eff1cac05d4ddac00ac6348d5d2be9a7cf11d886",
          "7240d609b5288fc42c8fc5c80225c8ea5989e041e5a8e864ae4a95a0302d5e08",
          "0e52d99282a83b05c641301c32ce03e42a7b6f89f9556f70e26aa64575192c03",
          "e95748580d064f1087ef90ae6930b9dfc704da258e01a3695e48829be176dd09",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "18",
        "vectorFrameSha256": [
          "89269dfa5709eb92795bd5182e6f3d961aa186fe788b916b61863453294a7915",
          "e11c32320a090787f8aeb9fed0dc3ff685a3a0ec298876f533eefa364a2881f6",
          "951a48a5376a13eb2e597e7c288c012c45b31dd7fe0870f8bd8a0c9bb11c26ed",
          "e4efd818bc6fae867f03433662896ff59d494da5b6577af5bb25c0c0290dca87",
          "581425a8d356dbec255f99e2590f845ee3fba8a4649509405770cb208ca15b73",
          "1d9c822a68fc2f68bafdc15423c13c19b20a36705685d7923ecd9e3be2c667f7",
          "d9722bb8851c32583529c54a4b5c5fa275b1c956f473cc5630065bf8966b3375",
          "e11c32320a090787f8aeb9fed0dc3ff685a3a0ec298876f533eefa364a2881f6",
          "89269dfa5709eb92795bd5182e6f3d961aa186fe788b916b61863453294a7915",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/19/frame-01.png",
          "/game/characters/attack-movies/19/frame-02.png",
          "/game/characters/attack-movies/19/frame-03.png",
          "/game/characters/attack-movies/19/frame-04.png",
          "/game/characters/attack-movies/19/frame-05.png",
          "/game/characters/attack-movies/19/frame-06.png",
          "/game/characters/attack-movies/19/frame-07.png",
          "/game/characters/attack-movies/19/frame-02.png",
          "/game/characters/attack-movies/19/frame-01.png",
          "/game/characters/attack-movies/19/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/19/frame-01.png",
              "/game/characters/attack-movies/19/frame-02.png",
              "/game/characters/attack-movies/19/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/19/frame-04.png",
              "/game/characters/attack-movies/19/frame-05.png",
              "/game/characters/attack-movies/19/frame-06.png",
              "/game/characters/attack-movies/19/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/19/frame-02.png",
              "/game/characters/attack-movies/19/frame-01.png",
              "/game/characters/attack-movies/19/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie19",
        "sourceCharacterId": 56,
        "sourceChildSymbol": "19_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/19.swf",
        "sourceSha256": "8594536954587802032f6108ff42ba4d8e829a0014f2f3f3bafd34a5974f20e9",
        "frameSha256": [
          "7933e6d605f3d929d12cc2ca12c97687d0f36cbdabb7e2541ff9a29669b924d9",
          "f86be887b3c05682d2305899e237ac4ba714b58e9252c52e1076536296e62834",
          "e13518c6cd0825f0c31564f03aa119c186af2679e244ccde7fc8d9ac5b20ac8d",
          "fbbbd4e8165df5ccb4eca589f1b1aec4cf44ca9586f5767f2915dc02af45c486",
          "c19d320b99fbcfe3883d3da684ee0ead31a7c861f4c96b9f9d5e9c7b95fa5280",
          "9bf0a204c1894c16022b6bb2b0332e2fbdccf45a4459b641f7a9d65b43e11028",
          "f4a1d1ea385e4090b6692d9c70aaf3450d471a38c43975fa668e6cfe4fcc01fd",
          "f86be887b3c05682d2305899e237ac4ba714b58e9252c52e1076536296e62834",
          "7933e6d605f3d929d12cc2ca12c97687d0f36cbdabb7e2541ff9a29669b924d9",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "19",
        "vectorFrameSha256": [
          "b5748e15e9818e07252d4272a34554d076db8b84f8d8b0e1f3018b418aca2591",
          "243a5e108e8d4332e7848c817d2fec300eea50f82792e4541cc99cea3e56c872",
          "3a8a7f1393cc92ae74be09bf43f214208ee00106ea7ae57f1dac9bdbbe2fe1a9",
          "c6b08030127da4b7ad11d09ed3d91368b2ab6163160bda26efa2eb884130fd6f",
          "7b9d4493099c571647c3c065de50cc309dd803de02c09d86eb5ae3697410f413",
          "fc5ba917ba0382b9ca027920ae863686e6056e503a5cbb45170ecf627a601e36",
          "eb1319044b79f227eae7efff2d34ef6a8ce23c2a1c52aa4125d84b1c5e46623d",
          "243a5e108e8d4332e7848c817d2fec300eea50f82792e4541cc99cea3e56c872",
          "b5748e15e9818e07252d4272a34554d076db8b84f8d8b0e1f3018b418aca2591",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      }
    },
    "gun": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/22/frame-01.png",
          "/game/characters/attack-movies/22/frame-02.png",
          "/game/characters/attack-movies/22/frame-03.png",
          "/game/characters/attack-movies/22/frame-04.png",
          "/game/characters/attack-movies/22/frame-05.png",
          "/game/characters/attack-movies/22/frame-06.png",
          "/game/characters/attack-movies/22/frame-07.png",
          "/game/characters/attack-movies/22/frame-02.png",
          "/game/characters/attack-movies/22/frame-01.png",
          "/game/characters/attack-movies/22/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/22/frame-01.png",
              "/game/characters/attack-movies/22/frame-02.png",
              "/game/characters/attack-movies/22/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/22/frame-04.png",
              "/game/characters/attack-movies/22/frame-05.png",
              "/game/characters/attack-movies/22/frame-06.png",
              "/game/characters/attack-movies/22/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/22/frame-02.png",
              "/game/characters/attack-movies/22/frame-01.png",
              "/game/characters/attack-movies/22/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie22",
        "sourceCharacterId": 56,
        "sourceChildSymbol": "22_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/22.swf",
        "sourceSha256": "7726a0555e6107cf95a79a606125e6ca62c7c9109a6be17673239a60e4d6e588",
        "frameSha256": [
          "0c365968be762343bee5b41c680d8b43a57c5abfe1c626f24758efc7d045b778",
          "a9d9a3bfe1f1c15ed018e7c47f023b9ee9a62f88974153f0ac7c168c53000c50",
          "a4ee2884f816f8731df45a5b8be11df48e4f3fb680683a576ca0133bb7d5d42a",
          "30b8a4f6f222416c28f23d8245bacc0da45a81616c346270f58b6c71f07ea56f",
          "153d198a9d9937f20e57bb2296c5b80664a6ac418c5cc449a2a1212ac22ed7df",
          "46e4fc674a0c76131028c55dabc72daa3e8678b6b4f7a909977a8f5a568a50b2",
          "a9fdc7836ca6d1772456a0c060a7fbaa08716837d4980f350b0d67b292514dfc",
          "a9d9a3bfe1f1c15ed018e7c47f023b9ee9a62f88974153f0ac7c168c53000c50",
          "0c365968be762343bee5b41c680d8b43a57c5abfe1c626f24758efc7d045b778",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "22",
        "vectorFrameSha256": [
          "457d417b3809bfb744ae834a757abf0324eaf664c2cdc80c3bbc860535b8619a",
          "75ea22c00b0f74ba52640cab9a7346e2f4d9e4083864f7ce2fd4d35725310968",
          "8149960bb4ea6ac14bf3402b241b288907bfbe9a7495577f989336446adbdea6",
          "e2b542ff39e8d4690cb0816f9f01f784e0fe348215943da1f11ca825b3c2019b",
          "5de5e4bce1d47eaed8f483436469cfc6d7f9887239e80122602b210b008c084d",
          "77ef49a19cb55cc4b9613b4d87f76553897ee44482d10acfca2d8c9ca524487f",
          "eda0cab0906146732d1bee9a04f4d17bc3a823f172e9f0bf8058f79b698977cd",
          "75ea22c00b0f74ba52640cab9a7346e2f4d9e4083864f7ce2fd4d35725310968",
          "457d417b3809bfb744ae834a757abf0324eaf664c2cdc80c3bbc860535b8619a",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/23/frame-01.png",
          "/game/characters/attack-movies/23/frame-02.png",
          "/game/characters/attack-movies/23/frame-03.png",
          "/game/characters/attack-movies/23/frame-04.png",
          "/game/characters/attack-movies/23/frame-05.png",
          "/game/characters/attack-movies/23/frame-06.png",
          "/game/characters/attack-movies/23/frame-07.png",
          "/game/characters/attack-movies/23/frame-02.png",
          "/game/characters/attack-movies/23/frame-01.png",
          "/game/characters/attack-movies/23/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/23/frame-01.png",
              "/game/characters/attack-movies/23/frame-02.png",
              "/game/characters/attack-movies/23/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/23/frame-04.png",
              "/game/characters/attack-movies/23/frame-05.png",
              "/game/characters/attack-movies/23/frame-06.png",
              "/game/characters/attack-movies/23/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/23/frame-02.png",
              "/game/characters/attack-movies/23/frame-01.png",
              "/game/characters/attack-movies/23/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie23",
        "sourceCharacterId": 60,
        "sourceChildSymbol": "23_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/23.swf",
        "sourceSha256": "96687cf8e562bcdb502063561f214497fe58dec67c0329930698fe3da0c823fc",
        "frameSha256": [
          "d84d85f2a00a57f3a5f3c3f62819a7e912903d2167f9b8e057babefb5e377284",
          "b3e6ffc8b2c8dce6111e8f6843e88922dac33f337e6c652bf37d467c7c2a0583",
          "d60117b21fe36d69fdaa1b9fee11c78e4fa8324ceb4ec0a19145ba7095eaea0f",
          "8657410580226500860bd63eedd39d9e45af3859addf34b32c841eb93baac3d1",
          "921dec50f460a29d397f629c70f3a4f1e864de87b1aa731dcc8738212369484f",
          "7805e0ad786e2729253f162167be6c811430ed6f862ddd8981cb1247f0883560",
          "20f7efaa6f264dfb9cf1917e8751b63b3b18011afe31af85ddb42d086ffde247",
          "b3e6ffc8b2c8dce6111e8f6843e88922dac33f337e6c652bf37d467c7c2a0583",
          "d84d85f2a00a57f3a5f3c3f62819a7e912903d2167f9b8e057babefb5e377284",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "23",
        "vectorFrameSha256": [
          "4147553ae86909a68e911b1dea7e0529c4cd03956354721575db66d0a3698adc",
          "c7d7418d6c695d34deb8fbe92cfdef3a6797263ab6bb4cda578cb6f713bcb5c1",
          "3bc6c64e4804af723421a5f576e99e980e9182e3e5e7ac18f531d597557cfc7a",
          "e70c92fa150bb28f72fc80fe152a5258a872b6fc54948716a58a6ee6da58adad",
          "b103709e1312fe1cf08d235e86abe31896a14f40c04c4ffc47193fb88b35eb5f",
          "71c84ccf52bae1f0d4682ca65822e22ba67f2a3809e177591c10169ef4a915b5",
          "c19f08a29408c1297b2d3046bd4e0c9e3356f190691686b63327dac571ab1f9c",
          "c7d7418d6c695d34deb8fbe92cfdef3a6797263ab6bb4cda578cb6f713bcb5c1",
          "4147553ae86909a68e911b1dea7e0529c4cd03956354721575db66d0a3698adc",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      }
    },
    "goldgun": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/30/frame-01.png",
          "/game/characters/attack-movies/30/frame-02.png",
          "/game/characters/attack-movies/30/frame-03.png",
          "/game/characters/attack-movies/30/frame-04.png",
          "/game/characters/attack-movies/30/frame-05.png",
          "/game/characters/attack-movies/30/frame-06.png",
          "/game/characters/attack-movies/30/frame-07.png",
          "/game/characters/attack-movies/30/frame-02.png",
          "/game/characters/attack-movies/30/frame-01.png",
          "/game/characters/attack-movies/30/frame-10.png"
        ],
        "width": 115,
        "height": 96,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/30/frame-01.png",
              "/game/characters/attack-movies/30/frame-02.png",
              "/game/characters/attack-movies/30/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/30/frame-04.png",
              "/game/characters/attack-movies/30/frame-05.png",
              "/game/characters/attack-movies/30/frame-06.png",
              "/game/characters/attack-movies/30/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/30/frame-02.png",
              "/game/characters/attack-movies/30/frame-01.png",
              "/game/characters/attack-movies/30/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie30",
        "sourceCharacterId": 56,
        "sourceChildSymbol": "30_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1.0005340576171875,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/30.swf",
        "sourceSha256": "c2ed9392177ec0475aeba07c227ecdea2701a982aa54d7dd40ec18bfaff5550b",
        "frameSha256": [
          "94ba144f41b57b431697e596043a0e6301f219a672e8ce7f1b246222a0b39883",
          "b531fb184b9c4b7da92b8495e18df0f8d5bd8aa561e0eb09c7fb85b3547a185f",
          "9687e78bd54086ce6a66e32145c72e65c099e025fb9b04eae803d4f9bae83e95",
          "7b39e1ba8b55dcb9c3e790d70b244b737cadfc9e711c04fe4da6fa57c7d7087c",
          "a8157915f48d2b1da2dd364d63ea646ca164b6db30b4973b0d859e7598c87579",
          "54a1f9d3df03bc8c215158de6ea270c9d68506cbcf62c4ad3bd09cf41fd1064b",
          "f95092041583784b26f12a7a8248f23777a8c30c96c1cad147c774ef560d3c25",
          "b531fb184b9c4b7da92b8495e18df0f8d5bd8aa561e0eb09c7fb85b3547a185f",
          "94ba144f41b57b431697e596043a0e6301f219a672e8ce7f1b246222a0b39883",
          "87529f69844aa84f6da55d3bc9b078a79914572b903bc2b1c86c1016180bc356"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "30",
        "vectorFrameSha256": [
          "02a6f1d9d19e34a9d81615bd985235119967dea7fcf81e3a55feb301c3b7a852",
          "3f11f1d3d9879a0fa6c1912c4b6838ed73e546548aed0cae2359cbb01a52e12a",
          "6e00d66bc23550de324e9eaa0a517a383759014e3b4a4a2668d06d54b5e78a06",
          "3c953c9404275c091be4e19c88d39bbde56bf870e4399db7f910c4aab4cde6b5",
          "a984218a10982f1412104a605c5436286265800abb5201dc616c517d42f82b20",
          "da24a08e1dd57cc9fe9e16b39ed84ceff476afd4c991e1f697e40901614853d5",
          "c72f2ebe47f5bd2bd086c705e2c34640660be87846e0bec09e03ee618fc6345c",
          "3f11f1d3d9879a0fa6c1912c4b6838ed73e546548aed0cae2359cbb01a52e12a",
          "02a6f1d9d19e34a9d81615bd985235119967dea7fcf81e3a55feb301c3b7a852",
          "3d3793e6c6f7b0ecf80ab77858199f8141ff84596871e68af8ac44bac4f58d73"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/31/frame-01.png",
          "/game/characters/attack-movies/31/frame-02.png",
          "/game/characters/attack-movies/31/frame-03.png",
          "/game/characters/attack-movies/31/frame-04.png",
          "/game/characters/attack-movies/31/frame-05.png",
          "/game/characters/attack-movies/31/frame-06.png",
          "/game/characters/attack-movies/31/frame-07.png",
          "/game/characters/attack-movies/31/frame-02.png",
          "/game/characters/attack-movies/31/frame-01.png",
          "/game/characters/attack-movies/31/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/31/frame-01.png",
              "/game/characters/attack-movies/31/frame-02.png",
              "/game/characters/attack-movies/31/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/31/frame-04.png",
              "/game/characters/attack-movies/31/frame-05.png",
              "/game/characters/attack-movies/31/frame-06.png",
              "/game/characters/attack-movies/31/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/31/frame-02.png",
              "/game/characters/attack-movies/31/frame-01.png",
              "/game/characters/attack-movies/31/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie31",
        "sourceCharacterId": 60,
        "sourceChildSymbol": "31_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/31.swf",
        "sourceSha256": "d0cfd7f5603561ce4ecef1bfb3111f505e2118113467fd027fb654f3753ea8db",
        "frameSha256": [
          "3ba5fa992ab3106cd6caff95b12ed2b7ff7ba5f918df09fb987cce592fad417f",
          "576cb53a344910121a432ee1243f0e2616547616edd37c3ed9797000bd02344f",
          "49e04a0452d0ffcdc1c2b98c0c3feba24047cebda980639489909b142d67d359",
          "e060bdce8d856d83815572d6b3fc33c081fb565f1862c2719892feec05bf247a",
          "0ed335c14a31eebf7c3472a36e8630696894a6da2872771770d8ee4b8caeb093",
          "f31963da730573f4e96586d97007c7c89fab7cfc483f99e35e99bff23c1ff3ba",
          "3f4ed9813d6b8b82f7947529e40fbe044c4faa6f3ab288335588780493449f7e",
          "576cb53a344910121a432ee1243f0e2616547616edd37c3ed9797000bd02344f",
          "3ba5fa992ab3106cd6caff95b12ed2b7ff7ba5f918df09fb987cce592fad417f",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "31",
        "vectorFrameSha256": [
          "8b53c38593728d1da234f8778e84eab6b8742033a22aa4d95d731a87fa076f8b",
          "c7f676d2567db6b83d6756fa3880baafc40e8cd59505b64ca6484dbd1068f01a",
          "27996cbdc683518dbc880b330682ef815e4d09e0f209320592dbbafacb480c91",
          "c880cd91881f0029600576a65b0bca482b50bccca574d60a5841b08f117a0828",
          "3adb1b658010f5251cda22ce9010ed776fc394a5fdac77b10a9b4010d8921bde",
          "f90041b97560cf92075191b32c41251f4af62519451bb1e8101dd43644b1166c",
          "fcadaf213c8d10c51470e37714ac54129439c26ad5f876ff505178b8ff36acb8",
          "c7f676d2567db6b83d6756fa3880baafc40e8cd59505b64ca6484dbd1068f01a",
          "8b53c38593728d1da234f8778e84eab6b8742033a22aa4d95d731a87fa076f8b",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      }
    },
    "axe3": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/28/frame-01.png",
          "/game/characters/attack-movies/28/frame-02.png",
          "/game/characters/attack-movies/28/frame-03.png",
          "/game/characters/attack-movies/28/frame-04.png",
          "/game/characters/attack-movies/28/frame-05.png",
          "/game/characters/attack-movies/28/frame-06.png",
          "/game/characters/attack-movies/28/frame-07.png",
          "/game/characters/attack-movies/28/frame-08.png",
          "/game/characters/attack-movies/28/frame-02.png",
          "/game/characters/attack-movies/28/frame-01.png",
          "/game/characters/attack-movies/28/frame-08.png"
        ],
        "width": 115,
        "height": 96,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/28/frame-01.png",
              "/game/characters/attack-movies/28/frame-02.png",
              "/game/characters/attack-movies/28/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/28/frame-04.png",
              "/game/characters/attack-movies/28/frame-05.png",
              "/game/characters/attack-movies/28/frame-06.png",
              "/game/characters/attack-movies/28/frame-07.png",
              "/game/characters/attack-movies/28/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/28/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie28",
        "sourceCharacterId": 56,
        "sourceChildSymbol": "28_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1.0005340576171875,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/28.swf",
        "sourceSha256": "50179707064163370352e1e00044aba22c41472b044682ed5e2a0ad7734047e8",
        "frameSha256": [
          "7f39409ea48e8269d75e7b4e1b914c5ac147405775f5e1f050c2330118d89568",
          "35c0de1fdd5290c118f2741b22a3f6dd10c5525081d3c6f5cc478451a0be05b7",
          "25e7c2c4ab831b6b709c394a293f449d1c30f708588c438799dcc30abe1525b8",
          "7cbf9bd95d0942b0d1f7e5be611c7525fa64b73cc574676aa00265f80dbe33ea",
          "90d50ba913ca729e0d72ee4f4157e7a5171390bb0068abda2a674f0fe3a013d0",
          "aa9b19f1033c3ed4a46f05d91496242179706cf9ed4acb65b3ca34f475196249",
          "e265cd072ac55a056c09f09faf40bda03e4589815084a7e0c592510436c0edb3",
          "87529f69844aa84f6da55d3bc9b078a79914572b903bc2b1c86c1016180bc356",
          "35c0de1fdd5290c118f2741b22a3f6dd10c5525081d3c6f5cc478451a0be05b7",
          "7f39409ea48e8269d75e7b4e1b914c5ac147405775f5e1f050c2330118d89568",
          "87529f69844aa84f6da55d3bc9b078a79914572b903bc2b1c86c1016180bc356"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "28",
        "vectorFrameSha256": [
          "a05aeb0d9c53f498434383b01ee38f395c29faba15e24b98e596d40422935b09",
          "957c22988e858d537abb6ecef626e078de9c7c3c5feb8f8f628e747c2b7ad870",
          "0e042a5be61e3136d73f86c8faf5a2f4fae7bd6ec8e3fdd9c2a12a3d8c0714b1",
          "58f8c9dae08784a7771e0b23918f74fb75a8b358ffe6e4e05ee37d52e35d18dc",
          "c595136d96d49e304a8d05413d319b8123374499f7dc31048c6a7472a374aa2f",
          "1790c0850795e40bfd2550d88747a864eed29f3a19b3ca58c4a6a63ec7e82310",
          "30faab1b6867ff66635af0732789be4da770a2713f64c9e7645c7fb7716d8674",
          "3d3793e6c6f7b0ecf80ab77858199f8141ff84596871e68af8ac44bac4f58d73",
          "957c22988e858d537abb6ecef626e078de9c7c3c5feb8f8f628e747c2b7ad870",
          "a05aeb0d9c53f498434383b01ee38f395c29faba15e24b98e596d40422935b09",
          "3d3793e6c6f7b0ecf80ab77858199f8141ff84596871e68af8ac44bac4f58d73"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/29/frame-01.png",
          "/game/characters/attack-movies/29/frame-02.png",
          "/game/characters/attack-movies/29/frame-03.png",
          "/game/characters/attack-movies/29/frame-04.png",
          "/game/characters/attack-movies/29/frame-05.png",
          "/game/characters/attack-movies/29/frame-06.png",
          "/game/characters/attack-movies/29/frame-07.png",
          "/game/characters/attack-movies/29/frame-08.png",
          "/game/characters/attack-movies/29/frame-09.png",
          "/game/characters/attack-movies/29/frame-01.png",
          "/game/characters/attack-movies/29/frame-08.png"
        ],
        "width": 141,
        "height": 96,
        "anchor": {
          "x": 26,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/29/frame-01.png",
              "/game/characters/attack-movies/29/frame-02.png",
              "/game/characters/attack-movies/29/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/29/frame-04.png",
              "/game/characters/attack-movies/29/frame-05.png",
              "/game/characters/attack-movies/29/frame-06.png",
              "/game/characters/attack-movies/29/frame-07.png",
              "/game/characters/attack-movies/29/frame-08.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7,
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 200,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/29/frame-08.png"
            ],
            "sourceFrames": [
              8
            ],
            "stopSourceFrame": 8,
            "durationMs": 40,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie29",
        "sourceCharacterId": 57,
        "sourceChildSymbol": "29_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/29.swf",
        "sourceSha256": "ce5efe574211a9ccb88ba9a9b5ed8f5b7e2e40ab5342aa166cee5e44feb36248",
        "frameSha256": [
          "f3e05b6a8967343bb0967e02058be048f1f5047ed22961907b113dc8f79c235d",
          "2b5047445f0bb7ed315b59460e33429270759942b1afbeb31f958656af683dc6",
          "7c62838a40a4a875a627a18cbc225b5195f7fc473e4ff62840e0ea91fbc03a30",
          "4d064c1ca173eda89ae0be536fa93720cd9796dedc6eca1b0da9cc6bbe86d6b7",
          "6dcb895805256bde4487cead670f6a81977e02da3cd527b17dd4331374fa93dc",
          "cbe3c586cfa63939772bdf33c8ce3c3f1e9e4e469a2428b9d50467f89f9baab4",
          "f65a8b6bcec43217a5f9428fc96a426a237c0cfa3ea97cbb357c144b9ceb90a2",
          "da2e73c36d014cce1ada59c3a904a967cd9623c5bacd8565be2726f5a3b06937",
          "14ec661482ce067c5d05e5049474dcb3189fdd8022b30f12afb1bcde20b9eb3c",
          "f3e05b6a8967343bb0967e02058be048f1f5047ed22961907b113dc8f79c235d",
          "da2e73c36d014cce1ada59c3a904a967cd9623c5bacd8565be2726f5a3b06937"
        ],
        "transparentSourceFrames": [
          8,
          11
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 0,
        "runtimeBallId": "29",
        "vectorFrameSha256": [
          "5b3e4feed5ca47830799215902082e53fe04822e0300a6a4878b6bcf24bb133f",
          "7c7e5f46377b3a36c685f8bfc53644eded09a5495fb3ff25d20939e28e9faaa8",
          "57d757c55845a1a1901c79c6f1c47a8e771269b5fbc5f41a59a26fe0120f5951",
          "020c0495c9d84af8b7bf293971abb0c6d47e6b7b81f31e87fff43dff0a5d9daf",
          "bf68580172c9cd2867a59afd10d7c333a22bade63e62275887a642829230b730",
          "743524d68fc0e5d70b7e3ae2948665aaacb1748381f6e22ae3cd44bf2320d94f",
          "e916cbe97fa69ba87e3036d5d2c7989e69ca8ec96ec969289dca4bccba7929b0",
          "9c278ce9ce1e3a8f14af4d4391d6cb5d7d1bd8a8c922ed3497706a514cd5cbaf",
          "b3a0f73fb128ed62928b5de70d33deb3c8aa88b420c8dfe2774857c224bbf90d",
          "5b3e4feed5ca47830799215902082e53fe04822e0300a6a4878b6bcf24bb133f",
          "9c278ce9ce1e3a8f14af4d4391d6cb5d7d1bd8a8c922ed3497706a514cd5cbaf"
        ]
      }
    },
    "bow3": {
      "normal": {
        "frames": [
          "/game/characters/attack-movies/42/frame-01.png",
          "/game/characters/attack-movies/42/frame-02.png",
          "/game/characters/attack-movies/42/frame-03.png",
          "/game/characters/attack-movies/42/frame-04.png",
          "/game/characters/attack-movies/42/frame-05.png",
          "/game/characters/attack-movies/42/frame-06.png",
          "/game/characters/attack-movies/42/frame-07.png",
          "/game/characters/attack-movies/42/frame-02.png",
          "/game/characters/attack-movies/42/frame-01.png",
          "/game/characters/attack-movies/42/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/42/frame-01.png",
              "/game/characters/attack-movies/42/frame-02.png",
              "/game/characters/attack-movies/42/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/42/frame-04.png",
              "/game/characters/attack-movies/42/frame-05.png",
              "/game/characters/attack-movies/42/frame-06.png",
              "/game/characters/attack-movies/42/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/42/frame-02.png",
              "/game/characters/attack-movies/42/frame-01.png",
              "/game/characters/attack-movies/42/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie42",
        "sourceCharacterId": 56,
        "sourceChildSymbol": "42_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/42.swf",
        "sourceSha256": "226e7238abd6894e31726a143c777ebd97a311277d79a009a776e339a31d20c4",
        "frameSha256": [
          "77658b8909189acdd1334616fbdd6e579d7836373e3bef308bf0e44ebe8d21c5",
          "5c44cb96b0f1fcc2644d2045a98a1e405acda3b653317d44a75fda931e9e73d0",
          "bade33c06799ab90d10be0a86ad05d35e5e06bbd52285d572bf0e135dd3318c0",
          "dba8a85e764d2a8cb07664a2b4ac12e3d5c6eec18b3452c1e601aa07fea93cc4",
          "c949217da87b00c697a0fe41be7acff8679cf1651d32a49ad4ebff0679e75d6f",
          "2f41c944e236b221e9b3b734b9b2fd35f0557de5ddaf1d14c1ec2c263d6c185e",
          "d2269d87362b919746eff1180e30b88195f1d9151b1167c20449c0f8ad20320c",
          "5c44cb96b0f1fcc2644d2045a98a1e405acda3b653317d44a75fda931e9e73d0",
          "77658b8909189acdd1334616fbdd6e579d7836373e3bef308bf0e44ebe8d21c5",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "42",
        "vectorFrameSha256": [
          "6be492620f1ba3c794b7499eac8cb5f8f1348650587be65034efb0a115e93408",
          "6f3ee5dda57df34312874e456cfef206bbf5c0342c0e50f1d4c722df1e79ea3f",
          "6b2bbf2e2632c59a976ca1c0dc2ee920bca5ea006c4ae894eb53b10ffcdb2366",
          "ad1f326f6df0cf753ad47be12c3b8ba6490a2bd0b3cdb7a7346ff9b52eec7b89",
          "e66ab204dcf958ed5e83f0fd9fb14db72560f9fe737dafb24361af8e5e6a9e35",
          "993a5354d94e9b5246452b76e38de4e1e395415a4423cfeccbb0277362af6679",
          "fa0364bf397fd50aceb2cc7365fc9c634c84628b40b76c348935e20253ee7071",
          "6f3ee5dda57df34312874e456cfef206bbf5c0342c0e50f1d4c722df1e79ea3f",
          "6be492620f1ba3c794b7499eac8cb5f8f1348650587be65034efb0a115e93408",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      },
      "special": {
        "frames": [
          "/game/characters/attack-movies/43/frame-01.png",
          "/game/characters/attack-movies/43/frame-02.png",
          "/game/characters/attack-movies/43/frame-03.png",
          "/game/characters/attack-movies/43/frame-04.png",
          "/game/characters/attack-movies/43/frame-05.png",
          "/game/characters/attack-movies/43/frame-06.png",
          "/game/characters/attack-movies/43/frame-07.png",
          "/game/characters/attack-movies/43/frame-02.png",
          "/game/characters/attack-movies/43/frame-01.png",
          "/game/characters/attack-movies/43/frame-10.png"
        ],
        "width": 115,
        "height": 95,
        "anchor": {
          "x": 0,
          "y": 0
        },
        "frameRate": 25,
        "sourceFileFrameRate": 25,
        "phases": {
          "start": {
            "frames": [
              "/game/characters/attack-movies/43/frame-01.png",
              "/game/characters/attack-movies/43/frame-02.png",
              "/game/characters/attack-movies/43/frame-03.png"
            ],
            "sourceFrames": [
              1,
              2,
              3
            ],
            "stopSourceFrame": 3,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "shot": {
            "frames": [
              "/game/characters/attack-movies/43/frame-04.png",
              "/game/characters/attack-movies/43/frame-05.png",
              "/game/characters/attack-movies/43/frame-06.png",
              "/game/characters/attack-movies/43/frame-07.png"
            ],
            "sourceFrames": [
              4,
              5,
              6,
              7
            ],
            "stopSourceFrame": 7,
            "durationMs": 160,
            "holdLastFrame": true,
            "lastFrameTransparent": false
          },
          "end": {
            "frames": [
              "/game/characters/attack-movies/43/frame-02.png",
              "/game/characters/attack-movies/43/frame-01.png",
              "/game/characters/attack-movies/43/frame-10.png"
            ],
            "sourceFrames": [
              8,
              9,
              10
            ],
            "stopSourceFrame": 10,
            "durationMs": 120,
            "holdLastFrame": true,
            "lastFrameTransparent": true
          }
        },
        "position": {
          "x": -62,
          "y": -83
        },
        "drawAfterCharacter": true,
        "sourceSymbol": "tank.resource.bombs.BombMovie43",
        "sourceCharacterId": 57,
        "sourceChildSymbol": "43_fla.1_2",
        "wrapperSourceFrame": 1,
        "wrapperMatrix": [
          1,
          0,
          0,
          1,
          0,
          0
        ],
        "sourcePath": "assets/candidate/original/ddtank-ii/bombs/43.swf",
        "sourceSha256": "4f75a700a5560ab57648e9a888af1156c73b4edcca79ea7b9b81333c54d26211",
        "frameSha256": [
          "ee6d0119453c4d85817ce5fc5ced09cc3281d53f5e8e403e144c254e721bfa53",
          "97bbf975a24d3b332b15543c261f5703fd6e9522d8564d3cbc98d20ee15ea22d",
          "e6f53bb5cdab806c91e13a1ed2466e1460ba623d181c5b60ebf89b8d53de6dbe",
          "61ca1796e707b2b908b278b77bcc29a4a7fb2f08532c009fdb6d2c5cbc919659",
          "a10656d2bdd14be5abb463a83d664e5c07bd077aa40a4c22a7920174c6484134",
          "3e91d956812ff26d207001b6766e85aa047de016ea9b6890b47a5f0b847e1bf9",
          "f962b325619345d4172ae1577714215768b219abba244e6690842ddae5de2fab",
          "97bbf975a24d3b332b15543c261f5703fd6e9522d8564d3cbc98d20ee15ea22d",
          "ee6d0119453c4d85817ce5fc5ced09cc3281d53f5e8e403e144c254e721bfa53",
          "f820dd33681c595572a6b9a09879dd8effcd6122bfafc61ea12ccc9dc7e318cc"
        ],
        "transparentSourceFrames": [
          10
        ],
        "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
        "actionType": 1,
        "runtimeBallId": "43",
        "vectorFrameSha256": [
          "09519edfbb4cb910be87830e768d498ea8bedbc4ddcabd8ea52f2740fae39440",
          "a3099251bd20ea69836ebdbc685354ec53a37fcbf120526bb863f35c0355773c",
          "4de63082495559e8b1305875a274320b5b8c84e99000beafc02fadc4158a53bb",
          "1e167eb38da48722413e2f5dbb1ff2a5aef4784e5aba09e730f66be428891f02",
          "9445650e91cafbfcd54e0c5ace40717d4bb701ab231704b879a1935be8be0d63",
          "0fc0b63f761fc01493bc83be7c5b608cb78d0cb463a4f759e17e37a6300c28ab",
          "3c3e60ff1e330da306f3dfa6c29daf7185dd5a9efb02d43825c1f25e2328b064",
          "a3099251bd20ea69836ebdbc685354ec53a37fcbf120526bb863f35c0355773c",
          "09519edfbb4cb910be87830e768d498ea8bedbc4ddcabd8ea52f2740fae39440",
          "fb00c7e5f6f1d5d2d62f8f0ff8f409e3a7590c9449d1f9c17af612ab4c73dde4"
        ]
      }
    }
  },
  "actions": {
    "fly": {
      "frames": [
        "/game/characters/attack-movies/3/frame-01.png",
        "/game/characters/attack-movies/3/frame-02.png",
        "/game/characters/attack-movies/3/frame-03.png",
        "/game/characters/attack-movies/3/frame-04.png",
        "/game/characters/attack-movies/3/frame-05.png",
        "/game/characters/attack-movies/3/frame-06.png",
        "/game/characters/attack-movies/3/frame-07.png",
        "/game/characters/attack-movies/3/frame-08.png",
        "/game/characters/attack-movies/3/frame-02.png",
        "/game/characters/attack-movies/3/frame-01.png",
        "/game/characters/attack-movies/3/frame-08.png"
      ],
      "width": 115,
      "height": 96,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "frameRate": 25,
      "sourceFileFrameRate": 25,
      "phases": {
        "start": {
          "frames": [
            "/game/characters/attack-movies/3/frame-01.png",
            "/game/characters/attack-movies/3/frame-02.png",
            "/game/characters/attack-movies/3/frame-03.png"
          ],
          "sourceFrames": [
            1,
            2,
            3
          ],
          "stopSourceFrame": 3,
          "durationMs": 120,
          "holdLastFrame": true,
          "lastFrameTransparent": false
        },
        "shot": {
          "frames": [
            "/game/characters/attack-movies/3/frame-04.png",
            "/game/characters/attack-movies/3/frame-05.png",
            "/game/characters/attack-movies/3/frame-06.png",
            "/game/characters/attack-movies/3/frame-07.png",
            "/game/characters/attack-movies/3/frame-08.png"
          ],
          "sourceFrames": [
            4,
            5,
            6,
            7,
            8
          ],
          "stopSourceFrame": 8,
          "durationMs": 200,
          "holdLastFrame": true,
          "lastFrameTransparent": true
        },
        "end": {
          "frames": [
            "/game/characters/attack-movies/3/frame-08.png"
          ],
          "sourceFrames": [
            8
          ],
          "stopSourceFrame": 8,
          "durationMs": 40,
          "holdLastFrame": true,
          "lastFrameTransparent": true
        }
      },
      "position": {
        "x": -62,
        "y": -83
      },
      "drawAfterCharacter": true,
      "sourceSymbol": "tank.resource.bombs.BombMovie3",
      "sourceCharacterId": 98,
      "sourceChildSymbol": "1_fla.chuansong1_12",
      "wrapperSourceFrame": 1,
      "wrapperMatrix": [
        1,
        0,
        0,
        1.0005340576171875,
        0,
        0
      ],
      "sourcePath": "assets/candidate/original/ddtank-ii/bombs/1.swf",
      "sourceSha256": "44fed4cbcec87efff901996ac97688eabb2d91a4d3c6db7e1cb66e6e19a017da",
      "frameSha256": [
        "5bf82ac614563b6c2ccf79b3a9c39cd6c062c0218d378f313b182c6a3a982d2e",
        "35c0de1fdd5290c118f2741b22a3f6dd10c5525081d3c6f5cc478451a0be05b7",
        "c5b850c8d0e52e7c6bf63b27beea5ed892c4df4cf3910db9713e8090b47fa113",
        "446bf5afebede2a520c5be746a762f241606b82ee43238b9dae68183006061ca",
        "82f093e0254afcecc0b97835ec2a280ec34e0d7ddd1364ce4eac5da6c648303d",
        "f7ddaf3835265d3c5656358218c2dbac9c58f531ecf4fceb92793699f10f5e46",
        "1374791267ca46eaf9be97c231b19ad67702626571c5386a4f21d4de6bc7b06a",
        "87529f69844aa84f6da55d3bc9b078a79914572b903bc2b1c86c1016180bc356",
        "35c0de1fdd5290c118f2741b22a3f6dd10c5525081d3c6f5cc478451a0be05b7",
        "5bf82ac614563b6c2ccf79b3a9c39cd6c062c0218d378f313b182c6a3a982d2e",
        "87529f69844aa84f6da55d3bc9b078a79914572b903bc2b1c86c1016180bc356"
      ],
      "transparentSourceFrames": [
        8,
        11
      ],
      "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
      "actionType": 0,
      "vectorFrameSha256": [
        "dd8c8ceb8006f0da6ad205a4f621e279548a26edf132939ca6600986ed384120",
        "3dc8c62224b82fd9414d3ade17c8de73225fe5554413d6c03eebe9b7c6303cea",
        "7a17fe34d0348a680cbb1a8825baa04f0530be6d90729b53f2d5727c0ee309d1",
        "d025db418e3bca7071d45d38f1f94ab6d05920edec979eb04a5ec6efb5d228a9",
        "a865f14b0e7b380b528d2c47774d8c48e9902c42082d674fd8e99cb4b00c7ef0",
        "dae67517bc9cb51a4722bd879be3d10d3ea7aece6d1e3261b86bfd865ace1777",
        "719d281ef0a58f36fcd04521acd76c9df2a32d7ae3861b286e2a39780a5e5379",
        "3d3793e6c6f7b0ecf80ab77858199f8141ff84596871e68af8ac44bac4f58d73",
        "3dc8c62224b82fd9414d3ade17c8de73225fe5554413d6c03eebe9b7c6303cea",
        "dd8c8ceb8006f0da6ad205a4f621e279548a26edf132939ca6600986ed384120",
        "3d3793e6c6f7b0ecf80ab77858199f8141ff84596871e68af8ac44bac4f58d73"
      ]
    },
    "ice": {
      "frames": [
        "/game/characters/attack-movies/1/frame-01.png",
        "/game/characters/attack-movies/1/frame-02.png",
        "/game/characters/attack-movies/1/frame-03.png",
        "/game/characters/attack-movies/1/frame-04.png",
        "/game/characters/attack-movies/1/frame-05.png",
        "/game/characters/attack-movies/1/frame-06.png",
        "/game/characters/attack-movies/1/frame-07.png",
        "/game/characters/attack-movies/1/frame-08.png",
        "/game/characters/attack-movies/1/frame-02.png",
        "/game/characters/attack-movies/1/frame-01.png",
        "/game/characters/attack-movies/1/frame-08.png"
      ],
      "width": 115,
      "height": 96,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "frameRate": 25,
      "sourceFileFrameRate": 25,
      "phases": {
        "start": {
          "frames": [
            "/game/characters/attack-movies/1/frame-01.png",
            "/game/characters/attack-movies/1/frame-02.png",
            "/game/characters/attack-movies/1/frame-03.png"
          ],
          "sourceFrames": [
            1,
            2,
            3
          ],
          "stopSourceFrame": 3,
          "durationMs": 120,
          "holdLastFrame": true,
          "lastFrameTransparent": false
        },
        "shot": {
          "frames": [
            "/game/characters/attack-movies/1/frame-04.png",
            "/game/characters/attack-movies/1/frame-05.png",
            "/game/characters/attack-movies/1/frame-06.png",
            "/game/characters/attack-movies/1/frame-07.png",
            "/game/characters/attack-movies/1/frame-08.png"
          ],
          "sourceFrames": [
            4,
            5,
            6,
            7,
            8
          ],
          "stopSourceFrame": 8,
          "durationMs": 200,
          "holdLastFrame": true,
          "lastFrameTransparent": true
        },
        "end": {
          "frames": [
            "/game/characters/attack-movies/1/frame-08.png"
          ],
          "sourceFrames": [
            8
          ],
          "stopSourceFrame": 8,
          "durationMs": 40,
          "holdLastFrame": true,
          "lastFrameTransparent": true
        }
      },
      "position": {
        "x": -62,
        "y": -83
      },
      "drawAfterCharacter": true,
      "sourceSymbol": "tank.resource.bombs.BombMovie1",
      "sourceCharacterId": 88,
      "sourceChildSymbol": "1_fla.bindan1_14",
      "wrapperSourceFrame": 1,
      "wrapperMatrix": [
        1,
        0,
        0,
        1.0005340576171875,
        0,
        0
      ],
      "sourcePath": "assets/candidate/original/ddtank-ii/bombs/1.swf",
      "sourceSha256": "44fed4cbcec87efff901996ac97688eabb2d91a4d3c6db7e1cb66e6e19a017da",
      "frameSha256": [
        "726a24889b5f081713569b359023e5aaad4402fa818e1112919b55b62a647ff3",
        "35c0de1fdd5290c118f2741b22a3f6dd10c5525081d3c6f5cc478451a0be05b7",
        "a1e7a188311a9f58edd942a337fa1bb2f5be3f5b13f0cea1c4e649bf0e187bc0",
        "afbebc0824dfb6f27d6f382a86a85f2deaccbe9c527e69443f02a59f3265f154",
        "d5724e01a71f6321d103854c90388e5e9c34e4f1ce247ff399cfca55fa9db653",
        "7df0efc634bf6bb45ec1fa7bfba613d8e3e0bd6d54af4703726da669d7c41649",
        "39f6ce134eb2f41a31135b979955945bee087724a9829a1308446e88e728827c",
        "87529f69844aa84f6da55d3bc9b078a79914572b903bc2b1c86c1016180bc356",
        "35c0de1fdd5290c118f2741b22a3f6dd10c5525081d3c6f5cc478451a0be05b7",
        "726a24889b5f081713569b359023e5aaad4402fa818e1112919b55b62a647ff3",
        "87529f69844aa84f6da55d3bc9b078a79914572b903bc2b1c86c1016180bc356"
      ],
      "transparentSourceFrames": [
        8,
        11
      ],
      "candidateConfidence": "Original archived DDTank-II source symbol; base form matches current legacy projectile visual id. Exact2009 animation/date unverified.",
      "actionType": 0,
      "vectorFrameSha256": [
        "6b1531cab0d61d4cac6cd978e92448816b93eb5f9502596feec197142a1d84c5",
        "60b54ad1f9f745e046577c3fe16c3e95b9d8d7e5d6ce3365f26009eb867aa9e3",
        "1a89a357befb3dfe664bd2437511c4de6d9542c606490cf90b989e1161e4f472",
        "d307760c49a2b78fd72cd14bf08235d45b6581c68be67d47d57f0b54ee82340f",
        "f3febd0aeaddd4299ebba8f50a5162a3602806c28981b480fae7ac54dc0623e9",
        "651acbf32e8b339f62fe21990ff58f3652520a402426df2d297105c259b2d00a",
        "8b5011b19cce480082bbfd3266c272c2deb769903ba9d3857723c624a97f4a70",
        "3d3793e6c6f7b0ecf80ab77858199f8141ff84596871e68af8ac44bac4f58d73",
        "60b54ad1f9f745e046577c3fe16c3e95b9d8d7e5d6ce3365f26009eb867aa9e3",
        "6b1531cab0d61d4cac6cd978e92448816b93eb5f9502596feec197142a1d84c5",
        "3d3793e6c6f7b0ecf80ab77858199f8141ff84596871e68af8ac44bac4f58d73"
      ]
    }
  },
  "evidence": "Original weaponMovie overlay from archived BombMovie classes; source frame labels and AVM2 stop-only frame functions read statically. No ActionScript executed or artwork generated.",
  "sourceRules": {
    "layer": "GamePlayer.weaponMovie is added after body and mirrors body.scaleX; position is GameCharacter.weaponX/weaponY=(-62,-83).",
    "coordinates": "Draw SVG at body origin + position - SVG anchor; SVG dimensions include original wrapper/child matrices. Do not stretch to114x95.",
    "variant": "Wrapper frame1 selects base weapon style, consistent with current original projectile base-form export.",
    "timing": "Each phase stops at the first actual stop() frame at or after its original label, including that stop frame. The 11-frame throw source end label8 itself has stop() and is transparent; frames9–11 are retained for audit but not inferred to play.",
    "body": "Held faceDown PNG remains before character; weaponMovie overlay is a separate layer after character."
  },
  "rasterization": {
    "renderer": "@resvg/resvg-js",
    "version": "2.6.2",
    "sourceScale": 1,
    "derivation": "Original recovered SWF vector/bitmap paths rendered at original canvas dimensions to lossless RGBA PNG; no redraw or ActionScript execution."
  }
}
